var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 682,
    height: 614,
    viewBox: "0 0 682 614",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_3490)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M552.013 275.985C552.013 428.389 428.417 551.931 275.994 551.931C235.44 551.986 195.378 543.06 158.684 525.797C151.659 522.502 144.792 518.891 138.096 515.029C111.367 499.589 87.4184 479.774 67.2489 456.408C59.8968 447.945 53.0738 439.037 46.8186 429.734C38.2642 417.029 30.7951 403.627 24.4902 389.669C8.32142 353.953 -0.0154075 315.19 0.0398234 275.985C-0.0110492 236.709 8.35308 197.877 24.5693 162.104C29.5828 151.009 35.3474 140.27 41.8231 129.96C55.7137 107.689 72.7226 87.5224 92.3319 70.0737C142.818 24.8788 208.23 -0.0639014 275.994 0.0395048C298.055 0.0253765 320.04 2.65358 341.476 7.86794C370.272 14.8757 397.742 26.5057 422.815 42.3051C427.639 45.3495 432.358 48.5125 436.945 51.8469C440.794 54.6013 444.577 57.4876 448.267 60.4529C466.386 74.8798 482.608 91.5384 496.549 110.033C526.353 149.478 544.926 196.253 550.3 245.396C551.453 255.552 552.025 265.765 552.013 275.985Z",
    fill: "url(#paint0_radial_110_3490)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.044 275.985C532.044 417.372 417.371 531.978 275.993 531.978C238.359 532.034 201.18 523.747 167.133 507.715C160.622 504.671 154.255 501.323 148.034 497.738C123.241 483.408 101.023 465.028 82.3012 443.361C75.4827 435.51 69.157 427.244 63.3603 418.61C55.4198 406.822 48.4801 394.391 42.6137 381.445C27.6215 348.32 19.8914 312.371 19.9426 276.012C19.8906 239.576 27.6482 203.553 42.6928 170.367C47.3432 160.072 52.694 150.107 58.7075 140.543C71.5974 119.883 87.3815 101.176 105.579 84.9926C152.414 43.0691 213.092 19.9294 275.954 20.0192C296.422 20.0093 316.818 22.4516 336.704 27.2941C363.416 33.7868 388.896 44.5714 412.151 59.2273C416.633 62.0608 420.996 64.9997 425.253 68.0837C428.838 70.6404 432.344 73.3553 435.798 76.0703C452.591 89.4826 467.626 104.958 480.547 122.131C508.202 158.714 525.433 202.103 530.41 247.69C531.486 257.083 532.031 266.53 532.044 275.985Z",
    fill: "url(#paint1_radial_110_3490)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M530.463 247.624C529.568 249.271 528.801 250.985 528.169 252.75C527.206 255.309 525.996 257.767 524.558 260.091C523.067 263.13 521.747 266.25 520.603 269.435C517.624 276.328 515.436 283.814 512.958 290.904C510.204 298.812 507.607 306.719 504.22 314.363C502.704 317.829 500.489 320.953 498.947 324.34C497.405 327.727 495.889 331.048 494.004 334.329C489.338 342.342 485.12 350.514 480.178 358.395C471.294 372.589 460.604 385.201 450.244 398.314C444.972 404.904 438.829 410.663 432.832 416.62C426.057 423.315 420.099 430.814 413.061 437.364C407.711 442.671 401.927 447.52 395.768 451.861C392.235 454.194 388.835 456.79 385.302 459.084C380.781 462.023 375.469 463.683 370.645 466.055C354.604 473.778 337.429 478.602 320.558 484.019C304.029 489.29 288.093 496.526 271.222 500.743C267.755 501.613 264.249 501.956 260.743 502.667C256.947 503.418 253.296 504.512 249.408 504.921C241.657 505.791 234.158 508.387 226.328 508.875C220.858 509.138 215.783 508.084 210.432 507.82C203.575 507.704 196.717 508.003 189.896 508.716C182.316 509.204 174.706 508.912 167.186 507.847C160.674 504.802 154.308 501.455 148.087 497.87L148.798 498.094C153.254 499.531 157.392 502.048 161.874 503.142C166.658 504.236 171.628 505.026 176.57 505.857C183.043 506.99 189.659 507.03 196.144 505.975C199.611 505.409 203.117 504.987 206.583 504.275C210.353 503.484 214.149 504.46 217.919 503.603C223.191 502.285 228.964 503.339 234.302 503.142C243.529 502.839 252.532 499.452 261.429 497.646C271.301 495.656 280.673 492.071 290.73 490.872C296.463 490.187 300.971 488.236 306.402 486.536C311.068 485.099 314.047 482.503 317.922 479.564C325.382 473.989 332.921 468.27 341.647 464.658C350.361 461.121 359.409 458.472 368.655 456.751C376.613 455.206 384.05 451.669 390.271 446.471C392.842 444.165 395.28 441.753 397.811 439.42C401.046 436.737 404.126 433.872 407.037 430.841C410.201 427.216 413.812 423.908 416.936 420.297C420.403 416.278 423.237 411.757 426.664 407.724C432.12 401.28 440.451 397.932 445.828 391.382C446.962 390.064 447.713 388.364 448.886 387.046C450.059 385.728 451.404 384.977 452.155 383.211C453.065 381.063 455.292 376.094 454.08 373.683C451.668 368.819 438.895 381.326 436.865 383.277C433.702 386.255 431.105 389.313 427.296 391.488C425.055 392.896 422.716 394.142 420.297 395.217C416.224 396.878 411.519 397.062 407.222 397.972C395.28 400.529 383.114 401.926 371.067 403.81C354.749 406.327 338.26 409.754 322.205 413.668C307.179 417.332 292.298 421.576 277.272 425.121C269.284 427.045 261.297 429.075 253.283 430.814C243.49 433.002 233.881 436.007 224.048 437.892C207.849 440.83 191.557 444.415 175.041 444.863C162.085 445.206 149.247 445.878 136.277 445.878C118.812 445.878 100.082 447.644 82.947 443.545C82.7275 443.5 82.5117 443.438 82.3012 443.361C75.4827 435.51 69.157 427.244 63.3603 418.61C69.6265 421.416 76.2004 423.478 82.947 424.752C87.8503 425.622 93.0436 426.742 97.1033 429.681C99.6436 431.734 102.508 433.351 105.579 434.465C116.73 438.05 126.668 437.826 137.832 434.544C142.006 433.305 146.149 432.014 150.262 430.669C153.306 429.641 156.101 427.836 159.145 427.006C167.779 424.752 176.702 423.131 185.402 421.141C189.54 420.192 193.877 419.401 197.95 418.162C202.537 416.726 206.834 414.393 211.236 412.588C219.672 409.121 227.514 405.55 236.556 403.995C242.237 403.059 248.828 402.347 254.034 399.711C255.721 398.881 258.252 397.708 257.988 395.455C257.685 392.661 254.034 393.412 252.031 393.754C246.192 394.769 240.247 395.296 234.447 396.838C224.203 399.503 213.714 401.119 203.143 401.662C187.247 402.716 171.048 403.665 155.112 402.835C142.458 402.189 129.726 401.056 117.072 401.174C104.827 401.293 92.925 400.239 81.2863 396.39C68.145 392.068 54.7664 388.114 42.6137 381.445C27.6215 348.32 19.8914 312.371 19.9426 276.012C19.8906 239.576 27.6482 203.553 42.6928 170.367C40.9924 175.046 39.5689 179.83 37.605 184.337C33.6583 193.039 31.545 202.46 31.3968 212.013C31.6342 215.749 31.6078 219.497 31.3177 223.229C30.6718 227.973 30.3028 231.031 31.6604 235.815C32.6753 239.321 32.9785 242.708 34.5206 246.095C35.016 247.153 35.7045 248.109 36.5505 248.915C37.3046 249.982 37.9744 251.105 38.554 252.276C40.6234 255.663 43.6023 260.183 47.1743 262.134C49.5626 263.32 52.0613 264.269 54.6346 264.967C57.6398 265.824 58.813 266.167 61.8314 265.073C64.2707 264.094 66.8274 263.439 69.4366 263.122C70.8724 263.281 72.2866 263.594 73.6545 264.058C75.4603 264.361 77.2397 264.203 79.085 264.585C86.6113 266.167 93.953 268.012 101.677 267.933C107.74 267.867 113.698 268.882 119.84 268.882C127.221 268.882 134.524 269.106 141.826 268.17C146.769 267.524 152.08 266.285 157.01 265.982C161.94 265.679 167.225 266.127 172.26 266.061C189.778 265.785 207.849 261.567 223.072 252.724C231.192 247.941 239.892 244.22 248.96 241.653C260.638 238.293 272.566 234.985 284.548 232.718C295.671 230.565 306.492 227.073 316.775 222.32C321.317 220.172 325.665 217.637 329.771 214.742C333.541 212.185 337.68 210.234 341.291 207.559C351.836 199.757 361.062 190.61 370.289 181.306C375.561 176.034 380.913 170.763 386.422 165.715C390.97 161.564 395.794 159.718 401.633 158.295C410.939 156.068 416.132 145.604 421.141 138.105C427.468 128.655 432.714 117.809 433.004 106.171C433.155 101.375 432.789 96.5764 431.909 91.8588C431.597 89.742 431.003 87.6765 430.143 85.7173C429.408 84.5236 428.79 83.2613 428.298 81.9481C428.034 80.8279 427.995 79.6549 427.771 78.6401C427.547 77.6253 427.019 76.5974 426.795 75.7803C426.268 73.5925 425.174 70.5745 425.319 68.1627V68.0177C428.904 70.5745 432.41 73.2894 435.864 76.0043C435.929 77.0062 435.903 78.012 435.785 79.0091C435.561 80.2216 435.139 81.2364 434.915 82.4357C434.612 84.2149 433.939 85.2297 433.979 87.1802C433.899 89.1285 434.049 91.0793 434.427 92.9923C435.666 97.7368 438.764 102.139 438.724 107.147C438.581 112.231 437.453 117.239 435.402 121.894C433.597 126.415 431.646 130.592 429.458 134.928C428.051 137.792 426.374 140.515 424.449 143.06C422.504 145.381 420.742 147.848 419.177 150.44C418.046 152.521 417.026 154.659 416.119 156.845C414.458 160.799 411.782 162.868 408.777 165.807C402.595 171.764 394.871 176.588 388.241 182.308C382.796 186.827 377.859 191.927 373.518 197.516C371.634 200.152 361.998 207.651 364.595 211.605C365.755 213.345 369.419 212.778 371.067 212.778C374.854 212.741 378.591 211.905 382.033 210.327C391.405 206.07 400.75 201.022 410.622 198.083C415.064 196.765 419.849 196.053 424.027 194.129C429.097 191.769 434.006 189.079 438.724 186.077C442.454 183.77 444.669 180.805 447.463 177.484C449.045 175.599 451.259 174.545 452.999 172.819C455.029 170.776 456.307 168.404 458.574 166.638C464.12 162.219 468.968 156.989 472.955 151.126C476.619 145.854 477.963 139.264 479.545 133.268C480.061 131.727 480.414 130.137 480.599 128.523C480.665 126.494 480.599 124.385 480.599 122.342V122.013C508.263 158.611 525.495 202.018 530.463 247.624Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.773 80.7884C412.797 86.5872 412.27 92.307 411.137 98.1058C410.003 103.905 409.713 110.349 407.367 115.7C403.413 124.925 402.174 135.166 395.926 143.297C393.29 146.763 391.207 150.493 387.82 153.392C386.528 154.242 385.17 154.987 383.76 155.62C382.442 156.49 381.045 157.808 379.806 158.743C373.097 163.646 365.979 168.694 360.035 174.558C353.668 180.818 347.605 186.96 340.079 191.889C337.812 193.352 335.439 194.406 333.106 195.698C331.295 196.898 329.406 197.976 327.451 198.927C325.081 199.659 322.827 200.724 320.756 202.09C318.925 203.443 316.938 204.572 314.837 205.45C311.226 206.874 307.72 208.574 304.108 209.971C302.447 210.643 300.708 211.025 299.02 211.618C294.236 213.437 290.73 213.279 284.522 213.766C282.571 212.91 284.232 212.831 285.84 212.119C286.831 211.668 287.705 210.996 288.397 210.155C289.733 208.713 291.193 207.39 292.76 206.202C295.475 204.238 299.06 203.263 301.986 201.497C305.716 199.164 309.407 196.33 313.019 193.813C316.076 191.704 318.37 188.383 320.927 185.747C323.642 182.888 326.924 180.331 329.89 177.655C333.357 174.571 336.335 171.066 339.841 168.008C343.469 164.923 346.464 161.163 348.659 156.938C349.635 155.132 351.217 153.814 352.232 151.969C353.295 150.301 354.25 148.567 355.092 146.777C355.962 144.628 357.095 142.625 358.031 140.556C359.085 138.144 359.046 135.284 359.573 132.767C361.155 125.229 362.671 117.624 364.055 110.046C365.029 103.604 365.509 97.0962 365.491 90.5805C365.715 84.3995 367.455 78.3766 367.482 72.1296C367.7 69.8415 367.394 67.5336 366.585 65.3819C365.267 62.4429 363.791 59.8862 362.737 56.8286C359.52 47.4212 353.55 39.1975 345.602 33.2247C344.402 32.3549 340.593 30.0617 336.823 27.3073C363.534 33.7999 389.015 44.5845 412.27 59.2404C414.326 66.2295 414.838 73.5817 413.773 80.7884Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.565 81.1969C339.011 84.439 337.047 86.8903 336.138 89.9743C335.097 93.479 334.317 97.0559 333.805 100.676C333.053 106.171 333.541 111.628 332.908 117.163C331.518 127.6 328.4 137.732 323.682 147.146C319.082 156.516 311.213 164.199 302.592 170.011C293.709 176.074 283.836 180.7 274.122 185.181C268.586 187.711 262.747 188.765 257.092 190.914C252.347 192.68 247.681 194.709 242.962 196.554C238.244 198.399 233.999 201.562 229.333 203.078C226.434 204.014 223.573 204.989 220.674 206.043C215.691 207.823 211.17 210.458 206.32 212.528C199.463 215.49 192.351 217.824 185.072 219.499C177.875 221.186 170.916 220.092 163.68 219.196C157.596 218.635 151.547 217.756 145.556 216.56C134.603 213.925 122.806 214.676 111.629 214.676C103.153 214.676 93.36 215.506 85.8601 210.906C83.7116 209.589 81.339 208.192 80.1396 205.938C78.6633 203.144 78.4788 199.612 77.8329 196.594C76.5148 190.386 70.6099 186.156 66.5765 181.609C61.3042 175.652 59.3007 168.127 58.2462 160.443C57.2346 153.825 57.3908 147.081 58.7076 140.516C71.5996 119.866 87.3835 101.168 105.579 84.9925C101.295 93.1241 98.0524 101.756 94.2826 110.152C88.6017 122.725 83.593 136.431 84.0807 150.48C84.2652 155.989 84.7133 162.157 87.6527 166.941C89.9198 170.631 93.65 173.306 97.2615 175.494C103.18 179.039 109.124 182.953 115.491 185.392C122.687 188.146 129.884 190.782 137.041 193.536C141.22 195.118 145.253 196.923 149.774 197.49C155.326 197.934 160.902 197.982 166.461 197.635C186.153 197.108 204.343 187.882 222.875 182.308C228.833 180.502 235.014 179.672 240.88 177.721C244.408 176.415 247.835 174.851 251.135 173.043C259.373 168.786 268.375 165.583 276.099 160.272C283.807 154.927 290.774 148.585 296.819 141.413C301.419 135.904 303.489 130.408 305.743 123.634C310.185 110.297 311.885 97.46 313.084 83.556C313.612 77.6517 315.655 72.38 317.039 66.6471C317.935 62.8515 317.408 58.476 314.402 55.7216C308.3 50.3445 299.297 46.9838 291.494 45.1782C286.749 44.0448 282.268 42.5424 277.338 42.5424C272.408 42.5424 267.729 42.5424 262.905 42.5424C258.081 42.5424 253.757 41.5276 249.118 41.5276C243.661 41.5276 238.573 43.0695 233.182 43.4913C227.538 43.8911 221.919 44.595 216.35 45.5999C209.76 46.7597 203.394 49.3956 196.988 51.3197C184.211 55.0926 172.222 61.1424 161.597 69.1775C158.961 71.2071 156.101 72.8282 153.346 74.6337C150.934 76.2547 150.064 78.0998 148.522 80.5116C145.378 85.2918 143.086 90.58 141.747 96.1421C140.91 100.166 140.617 104.284 140.877 108.386C140.811 113.931 140.268 119.46 139.256 124.912C137.938 132.596 130.556 144.009 138.689 150.15C139.82 150.965 141.101 151.548 142.458 151.865C143.816 152.181 145.223 152.226 146.597 151.995C150.75 151.33 154.85 150.374 158.869 149.136C170.138 145.973 181.922 142.203 193.6 140.727C197.146 140.279 200.494 140.543 204 139.647C206.188 139.04 208.257 138.329 210.472 137.907C215.599 136.971 220.726 133.65 224.746 130.303C226.592 128.761 228.108 126.876 230.019 125.334C232.576 123.225 235.66 121.828 238.112 119.562C241.618 116.333 244.966 112.827 248.248 109.361C254.983 102.284 259.847 93.4272 265.568 85.6383C269.192 80.6961 273.212 75.319 274.201 69.1775C274.952 64.433 269.153 61.9026 265.607 60.4002C261.759 58.7684 257.549 58.1819 253.402 58.7C247.642 59.728 242.369 63.1546 237.018 65.4478C225.234 70.614 212.08 71.8924 201.838 80.1689C198.108 83.1474 198.293 86.0073 197.133 90.1588C196.331 92.1444 195.361 94.0579 194.233 95.8785C192.691 98.7384 192.493 99.4501 193.284 102.468C194.075 105.486 194.8 109.506 198.227 110.824C201.192 111.997 205.977 110.982 208.547 109.361C209.993 108.219 211.573 107.258 213.253 106.501C214.347 106.079 217.023 104.84 218.077 105.183C219.962 105.895 218.565 107.054 217.774 108.082C217.094 108.978 216.523 109.951 216.073 110.982C215.871 112.02 215.487 113.015 214.94 113.921C211.935 117.347 205.951 119.074 201.759 120.51C198.108 121.828 195.366 123.291 191.373 123.331C185.982 123.331 188.17 119.377 187.418 115.423C186.364 110.415 180.591 108.544 179.958 103.338C179.325 98.1322 180.933 92.386 183.042 87.826C184.01 85.9132 185.134 84.0838 186.403 82.3567C188.394 79.3123 191.333 77.5067 194.378 75.464C203.341 69.5597 214.531 66.7262 224.694 63.2996C234.856 59.873 245.941 59.2799 255.998 55.6952C262.852 53.2438 270.049 52.4531 277.088 51.1747C283.599 50.015 289.333 52.5717 292.035 58.5155C294.908 64.8152 298.296 71.6288 296.292 78.6006C293.577 88.1951 290.387 97.7236 285.339 106.396C279.117 117.084 271.552 127.179 260.295 133.097C252.387 137.274 243.793 139.607 235.436 142.731C229.114 145.252 222.545 147.103 215.836 148.253C205.397 149.834 195.828 156.002 185.626 158.572C171.581 162.077 157.361 164.84 143.025 166.848C137.982 167.778 132.826 167.933 127.736 167.31C125.324 166.967 123.096 167.191 120.802 166.176C119.181 165.465 117.52 164.7 115.912 164.028C110.337 161.616 104.946 157.623 105.579 150.849C106.185 144.483 108.492 138.078 109.691 131.831C110.521 127.68 110.6 123.581 111.615 119.43C112.367 116.267 113.078 113.038 113.948 109.901C114.628 107.162 115.736 104.546 117.23 102.152C120.196 98.0004 122.503 93.1504 125.627 89.1967C126.968 87.748 128.176 86.1823 129.238 84.5181C129.957 82.9918 130.884 81.5725 131.993 80.3007C133.192 78.9828 134.023 77.2564 135.301 75.9384C137.81 73.6643 140.508 71.6095 143.368 69.7969C149.506 65.2811 156.091 61.408 163.021 58.2388C169.769 55.2998 176.808 53.3361 183.741 51.0034C189.962 48.8552 195.722 45.4681 201.904 43.0959C208.902 40.4885 216.185 38.719 223.6 37.8242C238.37 35.8501 253.25 34.8156 268.151 34.7271C286.841 34.8062 307.548 27.729 325.29 36.6513C329.816 38.7361 333.375 42.4695 335.241 47.0892C338.378 54.5976 339.917 62.6763 339.762 70.8117C339.723 74.2647 340.131 77.8494 339.565 81.1969Z",
    fill: "#C4B0B8"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2326 161.629C51.5507 165.082 53.2377 168.1 54.3581 171.606C55.0469 174.107 56.0571 176.508 57.3634 178.749C58.7605 181.016 59.6041 183.599 60.9354 185.932C62.4343 188.505 63.6075 191.254 64.4283 194.116C64.9687 196.225 65.0609 198.452 65.6409 200.587C66.379 203.315 67.1172 206.056 67.8817 208.785C68.4219 210.484 69.2079 212.096 70.2147 213.569C71.2164 215.176 72.3764 217.694 73.9449 218.84C78.9931 222.412 86.2294 220.896 92.0553 220.264C97.3277 219.697 102.732 219.657 108.044 218.946C110.835 218.629 113.65 218.563 116.453 218.748C119.137 218.88 121.809 219.184 124.454 219.657C126.747 220.105 128.975 220.171 131.281 220.54C134.59 221.068 137.872 221.858 141.193 222.201C144.897 222.491 148.707 223.031 152.41 223.11C157.683 223.203 163.126 222.662 168.425 223.229C173.047 223.91 177.702 224.35 182.37 224.547C188.447 224.547 194.51 222.741 200.151 220.685C209.549 217.259 219.237 214.465 228.675 211.012C232.09 209.542 235.371 207.778 238.481 205.74C241.368 204.053 244.465 202.946 247.246 201.088C252.508 197.83 258.312 195.544 264.381 194.34C270.313 193.022 276.047 190.874 281.925 189.49C285.879 188.568 289.649 186.564 293.577 186.05C292.839 189.134 286.104 190.255 283.691 191.124C278.116 193.114 272.066 194.208 266.675 196.633C263.156 198.228 260.651 201.272 257.883 203.856C255.247 206.228 253.415 208.692 250.476 210.656C247.59 212.623 244.327 213.969 240.893 214.61C233.314 216.125 225.92 218.84 218.367 220.514C210.815 222.188 203.433 223.914 196.487 227.104C194.563 228 188.908 230.227 188.671 233.008C188.486 235.235 191.188 234.418 192.757 234.418C196.131 234.418 200.586 233.614 203.763 234.945C206.034 236.075 208.409 236.984 210.854 237.66C216.622 238.642 222.549 238.022 227.989 235.868C235.239 233.047 243.16 231.611 250.779 230.161C256.051 229.146 261.179 227.631 266.438 226.524C270.484 225.806 274.568 225.322 278.67 225.074C284.627 224.507 290.598 223.822 296.516 222.834C301.248 222.03 306.428 221.516 310.765 219.447C314.363 217.68 318.581 216.573 321.758 214.096C322.601 213.437 327.399 209.299 328.519 210.247C330.852 212.251 317.579 219.802 316.657 220.422C312.38 223.13 307.829 225.378 303.08 227.13C297.044 229.594 290.849 230.675 284.627 232.243C277.457 234.023 270.313 235.499 263.182 237.317C256.051 239.136 248.683 240.046 241.552 242.431C237.966 243.534 234.468 244.905 231.087 246.53C228.002 248.111 224.72 249.166 221.676 250.813C215.085 254.332 208.93 259.274 201.799 261.567C195.6 263.712 189.173 265.127 182.647 265.785C174.093 266.47 165.512 265.271 157.05 264.388C148.379 263.373 139.655 262.88 130.926 262.911C122.859 263.043 114.805 264.73 106.752 265.112C101.203 265.376 96.7477 263.399 91.6467 261.501C86.0959 259.347 80.7714 256.65 75.7507 253.449C71.2596 250.634 66.0357 249.213 60.7377 249.363C59.6058 249.52 58.4899 249.776 57.4029 250.128C56.121 250.225 54.8448 249.876 53.7913 249.139C49.0462 246.912 44.288 243.248 41.9286 238.345C39.63 233.067 38.1328 227.474 37.4867 221.753C37.2362 218.468 37.1966 215.171 37.3681 211.882C37.3681 207.519 36.5772 203.223 36.6168 198.834C36.6168 191.902 35.8259 184.548 38.0139 177.84C40.057 171.527 44.2616 165.636 48.0972 160.311C50.2852 157.293 52.0515 154.051 54.3318 151.086C55.1358 152.668 53.2246 155.699 52.8292 157.333C52.3415 159.666 51.4584 163.975 50.2326 161.629Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.667 199.454C373.624 202.09 369.947 205.477 369.38 208.943C368.813 212.409 372.596 211.816 375.048 211.447C380.32 210.617 385.856 210.129 390.865 208.047C393.83 206.821 396.598 205.121 399.564 203.882C402.016 202.841 404.639 202.472 407.09 201.444C412.929 198.979 419.217 197.675 425.003 195.012C430.071 192.458 434.68 189.083 438.645 185.023C441.492 182.294 444.234 180.173 446.198 176.654C447.634 174.018 449.348 171.514 450.534 168.746C451.99 165.046 452.943 161.168 453.368 157.214C453.651 155.112 453.678 152.984 453.447 150.875C452.788 146.052 447.938 145.604 443.838 146.17C438.79 146.869 434.73 149.808 430.987 153.023C427.244 156.239 424.397 159.824 420.311 162.249C415.816 164.99 411.44 167.758 407.13 170.723C404.801 172.193 402.632 173.903 400.658 175.823C399.024 177.497 397.442 179.29 395.662 180.818C393.825 182.325 391.872 183.687 389.823 184.891C388.176 185.919 386.66 187.368 384.973 188.251C382.76 189.36 380.732 190.805 378.962 192.535C377.687 193.639 376.589 194.932 375.707 196.37C374.323 198.979 374.599 202.195 375.667 199.454Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.19 129.525C435.06 126.81 435.64 125.795 438.144 124.49C439.7 123.673 440.78 123.462 441.901 125.189C443.931 128.523 442.467 132.582 441.149 135.798C440.2 138.144 436.417 140.503 434.691 137.551C433.531 135.548 433.57 129.644 436.338 128.813L434.19 129.525Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.094 228.712C221.412 226.273 221.715 226.01 224.048 225.127C225.525 224.391 227.116 223.909 228.754 223.703C230.77 223.506 232.972 222.386 235.015 223.15C238.152 224.27 237.559 227.025 235.436 228.975C234.592 229.887 233.503 230.537 232.299 230.847C230.658 231.277 228.973 231.516 227.278 231.558C224.404 231.558 222.005 231.677 219.501 229.99C219.436 229.728 219.466 229.451 219.587 229.209C219.708 228.968 219.911 228.777 220.16 228.672L220.094 228.712Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.188 409.201C108.377 412.053 116.982 413.527 125.653 413.563C135.913 413.855 146.181 413.547 156.404 412.64C163.205 411.995 169.954 412.166 176.729 411.204C180.011 410.729 183.135 410.874 186.417 410.716C188.302 410.637 190.279 409.517 192.124 410.097C199.255 412.271 186.588 416.37 185.151 417.082C179.998 419.638 174.238 420.521 168.768 422.116C166.659 422.722 164.51 423.329 162.441 424.04C160.538 424.889 158.584 425.616 156.589 426.215C148.192 428.047 139.796 428.851 131.426 430.656C128.275 431.482 124.991 431.674 121.765 431.223C118.417 430.604 115.293 428.587 112.314 427.098C108.588 425.451 105.008 423.494 101.611 421.246C99.867 420.076 98.2305 418.753 96.7212 417.293C96.0771 416.433 95.6274 415.444 95.4031 414.393C94.5595 412.232 94.5991 411.362 96.4576 409.78C97.132 409.171 97.9524 408.747 98.8393 408.548C99.7261 408.35 100.649 408.384 101.519 408.647C101.532 408.858 101.572 409.056 100.188 409.201Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.382 493.455C313.122 494.646 309.075 496.496 305.387 498.938C303.779 500.071 301.802 502.008 304.175 503.458C307.378 505.409 312.584 504.367 316.037 504.064C321.995 503.524 327.9 502.43 333.805 501.652C337.838 501.112 341.793 500.69 345.773 499.886C350.952 498.737 356.054 497.267 361.05 495.485C364.756 494.297 368.298 492.65 371.595 490.582C375.109 488.615 378.486 486.414 381.704 483.992C385.803 480.553 391.208 477.864 392.789 472.368C394.107 467.795 384.222 469.443 382.245 469.733C374.905 470.781 367.693 472.578 360.72 475.096C357.702 476.164 354.473 476.981 351.494 478.273C347.54 480.025 343.757 482.108 339.723 483.663C337.812 484.414 336.138 485.613 334.2 486.299C332.5 486.931 330.787 487.498 329.099 488.183C327.412 488.869 325.33 489.804 323.405 490.424C319.056 491.913 314.68 493.112 317.382 493.455Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.375 460.151C397.126 457.687 398.707 456.553 400.54 454.774C401.963 453.39 403.321 451.901 405.39 451.611C406.919 451.387 409.344 453.153 408.672 454.906C408.1 455.871 407.405 456.757 406.603 457.542C405.927 458.629 404.995 459.534 403.888 460.178C401.677 461.191 399.17 461.35 396.849 460.626L396.375 460.151Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.064 400.212C420.332 401.253 418.51 402.135 416.62 402.848C415.185 403.178 413.733 403.429 412.271 403.599C407.908 404.285 403.4 404.588 398.997 405.023C393.369 405.576 387.781 406.341 382.152 406.802C372.214 407.553 361.762 408.41 352.258 411.467C344.261 414.019 336.521 417.315 329.139 421.312C322.593 424.695 316.368 428.665 310.541 433.173C308.645 434.78 306.853 436.505 305.176 438.34C303.955 439.479 302.935 440.815 302.158 442.293C301.117 444.639 302.066 446.247 304.122 447.565C307.325 449.608 311.213 449.792 314.877 450.293C320.321 451.044 325.738 451.73 331.156 452.573C336.76 453.492 342.409 454.107 348.08 454.418C353.893 454.682 359.943 454.563 365.479 452.455C369.404 451.05 373.213 449.335 376.867 447.328C380.426 445.285 383.971 443.269 387.346 440.936C389.851 439.459 392.232 437.78 394.463 435.915C395.399 435.032 396.348 434.267 397.323 433.45C398.839 432.132 399.96 430.538 401.475 429.259C404.909 426.386 408.004 423.132 410.702 419.559C412.785 416.818 415.315 414.485 417.372 411.744C418.584 410.11 419.85 409.253 420.574 407.25C421.348 404.971 421.848 402.609 422.064 400.212Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.953 392.068C434.873 390.381 436.118 388.893 437.617 387.692C438.817 386.559 440.399 384.569 442.059 384.041C442.47 383.872 442.919 383.818 443.358 383.886C443.797 383.953 444.209 384.139 444.55 384.424C444.844 384.767 445.062 385.169 445.189 385.603C445.316 386.037 445.35 386.493 445.289 386.941C444.946 388.944 442.995 390.499 441.334 391.369C439.265 392.437 438.052 391.896 435.877 391.593L433.953 392.068Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M509.611 321.243C508.519 322.084 507.529 323.048 506.658 324.116C505.34 326.027 504.233 328.069 502.704 329.822C501.162 331.77 499.79 333.846 498.605 336.03C497.049 338.745 495.217 341.301 493.767 344.029C490.63 349.986 488.139 356.26 485.332 362.375C483.921 365.432 482.695 368.569 481.377 371.6C479.808 374.85 478.678 378.293 478.016 381.84C477.608 384.397 476.949 388.786 480.389 389.247C484.659 389.827 488.956 386.15 492.067 383.699C500.203 377.157 507.181 369.293 512.708 360.437C518.244 351.686 523.609 341.169 522.225 330.508C521.718 325.681 521.824 320.81 522.541 316.01C523.2 310.91 524.769 305.81 524.861 300.644C524.861 296.98 525.533 293.395 524.729 289.784C524.619 288.604 524.063 287.51 523.174 286.726C522.225 286.173 521.566 286.726 520.709 287.372C518.144 289.234 516.079 291.702 514.698 294.555C513.011 298.06 512.919 301.843 511.496 305.441C511.1 306.72 510.638 307.978 510.112 309.21C509.584 310.198 508.938 311.147 508.398 312.149C507.587 313.957 506.994 315.855 506.632 317.803C506.315 319.002 506.131 320.122 505.801 321.322C505.538 322.257 505.129 323.259 504.945 324.208C504.76 325.157 505.09 325.921 509.611 321.243Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.121 384.516C469.265 385.359 464.084 390.367 466.088 391.646C466.642 392.002 468.171 391.646 468.724 391.395C469.769 390.899 470.726 390.236 471.558 389.432C472.092 389.048 472.507 388.522 472.757 387.914C473.006 387.306 473.079 386.64 472.968 385.992C472.968 383.738 471.545 383.804 469.647 384.568L470.121 384.516Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482.485 396.403C483.592 394.927 483.908 394.295 485.464 393.689C486.599 393.025 487.801 392.482 489.049 392.068C490.696 391.804 491.461 392.423 491.593 394.084C491.83 396.917 488.337 400.581 486.768 402.598C484.869 405.213 482.655 407.585 480.178 409.662C476.606 412.456 474.009 407.948 475.341 404.601C476.145 402.571 476.474 400.173 477.74 398.367C479.717 395.534 482.669 395.547 485.833 394.967L482.485 396.403Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.531 88.1292C205.023 88.9468 203.706 90.0741 202.666 91.4369C201.625 92.7998 200.885 94.3674 200.494 96.0367C199.993 97.6577 199.36 101.111 200.718 102.508C203.038 104.906 209.259 102.284 211.513 101.414C215.902 99.7268 220.371 97.2228 224.944 96.1421C233.578 94.152 243.055 93.3481 250.476 88.0369C254.664 84.8915 258.28 81.0486 261.165 76.6765C263.037 73.9484 265.502 71.7342 265.752 68.2154C266.24 61.0986 256.301 60.6242 251.622 61.7181C241.627 63.9227 231.903 67.2152 222.624 71.5366C217.168 74.1724 210.393 77.5199 206.544 82.4226C205.57 83.7894 204.79 85.284 204.224 86.864C203.749 87.9842 202.695 91.2131 206.531 88.1292Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.089 108.109C223.916 105.473 223.336 105.249 225.287 103.654C226.933 102.39 228.699 101.291 230.559 100.373C232.776 99.269 235.227 98.7174 237.703 98.7648C242.686 99.3578 240.419 104.972 238.877 107.674C237.914 109.374 237.203 110.942 235.594 111.852C233.696 112.932 232.418 113.486 230.322 112.787C228.848 112.224 227.503 111.367 226.368 110.27C225.524 109.519 223.56 108.148 223.732 106.804L224.351 106.685L225.089 108.109Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.108 169.484C190.226 167.125 190.029 166.598 191.505 165.109C193.693 162.868 196.909 161.155 199.493 159.494C205.385 155.755 211.739 152.795 218.394 150.691C224.309 148.792 230.371 147.386 236.517 146.487C241.104 145.775 245.441 144.259 250.054 143.614C257.159 142.638 265.871 139.199 271.552 145.933C276.113 151.389 267.677 158.611 263.644 161.577C260.222 164.045 256.32 165.764 252.189 166.624C247.273 167.863 242.422 169.339 237.506 170.578C228.372 172.845 219.883 177.168 211.144 180.608C205.121 182.953 200.824 182.729 195.406 179.145C192.467 177.128 187.472 171.975 190.108 169.484Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.896 128.813C271.71 131.001 268.758 135.007 272.567 136.378C274.729 137.156 276.284 135.416 277.839 134.177C279.395 132.938 281.701 131.541 282.887 129.525C283.227 129.1 283.458 128.598 283.559 128.063C283.66 127.528 283.629 126.976 283.468 126.456C283.306 125.936 283.02 125.463 282.634 125.079C282.248 124.695 281.774 124.412 281.253 124.253C276.785 122.263 274.663 126.546 272.119 129.525L272.896 128.813Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.847 85.2825C338.893 89.3944 336.507 94.1784 337.153 100.017C337.799 105.855 341.608 106.949 346.379 104.564C347.817 103.976 349.202 103.266 350.518 102.442C351.836 101.414 352.653 99.4896 353.655 98.1454C355.928 95.3077 357.136 91.7641 357.069 88.1292C357.069 84.5312 357.491 80.6829 356.529 77.2036C356.001 75.2794 355.211 72.6963 353.523 71.5102C351.52 70.1923 349.991 71.9451 348.528 73.1312C347.111 74.0158 345.89 75.1821 344.943 76.5578C343.358 79.5424 342.149 82.712 341.344 85.9941L342.847 85.2825Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.194 208.02C262.365 205.305 262.286 205.121 264.25 203.618C265.687 202.42 267.197 201.311 268.771 200.297C271.799 198.653 275.123 197.627 278.551 197.279C281.259 196.935 284.009 197.393 286.459 198.597C288.002 199.467 288.291 201.233 287.909 203.065C287.369 205.635 284.812 207.269 282.901 208.785C280.989 210.3 278.353 212.33 275.941 212.91C273.036 213.783 269.957 213.905 266.991 213.266C265.199 212.791 261.416 212.04 261.455 209.496L262.194 208.02Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.162 183.046C298.915 180.568 300.023 178.367 302.698 176.746C303.858 176.034 306.771 173.86 308.261 173.86C308.86 173.974 309.413 174.262 309.849 174.689C310.285 175.116 310.585 175.662 310.712 176.258C310.871 177.51 309.645 179.184 308.972 180.212C307.47 182.468 305.365 184.258 302.896 185.378C301.792 185.953 300.513 186.094 299.311 185.774C297.993 185.405 297.518 184.179 296.451 183.784L297.162 183.046Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.999 77.4277C154.493 80.907 151.633 84.584 150.499 89.5657C150.23 90.2835 150.182 91.0658 150.363 91.8108C150.544 92.5559 150.945 93.2293 151.514 93.7435C153.373 95.3909 155.745 94.4947 157.92 93.7435C164.009 91.6744 169.783 88.0369 175.055 84.5181C179.906 81.3287 186.404 80.4325 190.121 75.7935C192.137 73.2894 194.246 70.5218 192.309 67.2006C190.622 64.3671 186.338 63.1546 183.319 63.1019C178.924 63.1581 174.614 64.3183 170.784 66.4758C165.847 69.2543 161.503 72.9753 157.999 77.4277Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.63
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.017 62.4429C144.766 61.125 150.591 59.7411 156.47 56.1432C157.656 55.4315 158.843 55.0889 159.976 54.4431C161.11 53.7974 161.294 53.0461 162.138 52.2554C161.558 49.5141 154.163 51.1615 152.463 51.8864C150.196 52.8353 147.903 54.1664 145.701 55.2734C144.51 55.8025 143.364 56.4284 142.274 57.1449C140.073 58.7791 138.755 61.6126 137.279 63.8662L138.017 62.4429Z",
    fill: "#C4B0B8"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.842 212.831C345.903 214.05 343.896 215.159 341.832 216.152C338.444 217.536 335.36 219.486 331.999 220.936C328.045 222.649 323.774 223.782 319.701 225.179C313.943 227.047 308.406 229.535 303.186 232.599C297.913 235.815 292.878 240.507 290.176 246.095C288.634 249.324 288.001 253.686 289.886 256.941C290.986 259.003 292.675 260.691 294.737 261.791C298.203 263.346 301.577 262.358 305.057 261.541C309.46 260.581 313.725 259.071 317.75 257.047C319.899 255.927 321.942 254.622 324.09 253.488C326.239 252.355 328.835 251.432 331.195 250.47C333.027 249.719 334.899 249.06 336.784 248.467C339.098 247.697 341.264 246.538 343.189 245.041C347.023 242.289 350.226 238.754 352.587 234.668C355.527 229.397 357.056 224.02 356.041 218.115C355.25 213.542 351.889 211.302 347.842 212.831Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.125 245.607C281.807 243.854 280.963 244.026 278.854 244.144C277.224 244.32 275.608 244.606 274.017 245.001C266.108 246.662 258.042 247.505 250.186 249.521C245.834 250.478 241.619 251.974 237.638 253.976C233.684 256.111 229.558 258.022 225.67 260.355C216.805 265.864 207.079 269.846 196.896 272.137C190.529 273.455 184.163 274.773 177.77 275.959C173.922 276.67 170.02 277.277 166.184 278.068C162.349 278.858 158.553 279.978 154.704 280.835C147.814 282.242 141.035 284.145 134.419 286.529C127.683 289.072 120.816 291.431 115.544 296.532C112.842 299.167 109.375 302.976 109.388 306.983C109.53 309.809 110.441 312.544 112.024 314.89C117.297 323.615 127.433 328.794 136.238 333.262C148.443 339.456 162.955 340.26 176.307 341.802C193.741 343.683 211.362 342.793 228.517 339.166C236.227 337.598 243.991 336.069 251.728 334.619C261.06 332.867 270.498 331.628 279.803 329.677C287.461 328.056 295.172 326.264 302.698 324.076C306.837 322.934 310.893 321.512 314.838 319.819C318.267 318.171 321.598 316.327 324.816 314.297C327.562 312.784 330.204 311.089 332.724 309.223C334.81 307.413 336.677 305.365 338.287 303.121C341.028 299.589 342.794 295.688 344.982 291.853C346.42 289.15 348.004 286.528 349.727 283.998C351.507 281.56 353.603 279.267 355.54 276.947C359.6 272.058 364.582 267.84 368.378 262.766C370.593 259.814 372.754 256.098 373.058 252.368C373.268 249.825 373.282 247.215 370.619 246.055C368.015 245.048 365.191 244.748 362.434 245.185C359.676 245.724 356.968 246.495 354.341 247.492C349.667 248.837 345.134 250.628 340.804 252.843C329.943 258.668 319.253 265.903 307.022 268.499C301.973 269.58 296.925 270.134 292.075 268.13C288.436 266.738 284.972 264.924 281.754 262.727C277.536 259.683 278.815 256.071 280.66 251.907C281.451 250.062 283.744 246.068 283.125 245.607Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M517.69 188.989C517.658 193.433 517.301 197.869 516.623 202.261C516.346 204.225 516.016 206.215 515.713 208.139C515.305 210.775 514.053 213.094 513.433 215.69C512.326 220.343 510.112 224.375 508.161 228.685C506.21 232.995 504.892 237.713 502.888 242.141C497.432 254.688 494.176 267.985 488.851 280.572C486.215 286.805 483.816 293.25 480.942 299.352C478.306 304.848 475.182 310.106 472.454 315.536C471.426 317.566 468.618 321.308 470.754 323.443C472.454 325.13 475.551 323.575 477.344 322.613C484.514 318.778 487.559 309.698 491.975 303.332C494.215 300.116 497.656 297.691 499.989 294.502C503.033 290.337 506.645 285.369 508.648 280.664C512.814 270.924 515.371 260.829 518.982 250.892C521.974 242.681 522.422 234.721 522.422 226.102C522.422 222.491 522.831 218.867 521.737 215.414C520.735 212.158 519.944 206.768 517.69 188.989Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504.378 201.352C501.347 204.264 495.152 211.42 498.104 216.178C499.725 218.814 504.444 217.654 506.105 215.414C507.528 213.49 507.225 210.274 507.225 208.02C507.225 206.781 507.634 204.923 507.225 203.803C506.817 202.683 505.643 202.485 505.393 201.352H504.378Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.33 339.351C442.454 341.647 438.733 344.196 435.192 346.981C431.801 349.265 428.215 351.246 424.476 352.899C415.046 357.383 405.031 360.516 394.727 362.203C381.546 364.51 367.996 366.263 355.184 370.493C345.457 373.696 335.822 377.083 326.186 380.522C317.092 383.738 306.758 386.045 298.665 391.488C296.675 392.805 293.999 394.901 294.711 397.59C295.844 401.886 304.662 402.057 307.799 402.189C317.263 402.584 326.859 402.189 336.336 402.189C340.883 402.189 345.444 401.939 349.978 402.387C355.623 402.947 361.31 402.947 366.955 402.387C374.059 401.754 381.454 401.899 388.334 399.751C401.515 395.52 414.603 390.525 427.508 385.478C439.08 380.905 455.873 371.455 454.858 356.998C454.423 350.738 450.548 341.987 446.33 339.351Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.363 350.738C463.438 346.784 462.924 345.743 465.007 342.092C466.325 339.773 470.279 336.359 473.232 336.346C479.123 336.346 479.308 343.094 477.99 347.192C476.83 350.777 475.354 356.233 471.07 356.418C470.397 356.52 469.71 356.468 469.059 356.268C468.409 356.067 467.812 355.722 467.313 355.258C465.916 354.23 463.992 350.948 462.502 350.698L465.363 350.738Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5225 362.151C49.4549 366.632 48.809 370.717 50.997 375.027C54.0154 381.023 60.6849 385.043 66.814 386.98C70.6716 388.105 74.6596 388.721 78.6767 388.812C83.1714 389.023 87.6529 389.722 92.1476 389.801C98.8759 389.884 105.591 390.416 112.248 391.395C115.952 391.936 119.537 393.016 123.228 393.464C126.099 393.772 128.95 394.238 131.769 394.861C137.78 396.258 143.764 396.298 149.827 397.141C156.257 397.896 162.762 397.745 169.15 396.693C174.699 395.863 180.578 395.125 183.214 389.761C185.283 385.544 183.767 383.277 180.077 380.404C176.795 377.847 171.285 376.74 167.436 375.475C161.545 373.524 155.692 371.719 149.642 370.203C141.207 368.16 133.087 365.156 124.744 362.691C107.609 357.643 91.1722 350.606 73.2462 348.985C65.8254 348.299 57.047 348.22 50.193 351.621C47.9861 352.814 46.3036 354.788 45.4742 357.156C43.998 360.727 45.7774 362.876 50.5225 362.151Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5205 330.758C50.5091 333.895 50.3113 334.87 53.2111 335.753C55.0751 336.523 57.1264 336.72 59.103 336.319C61.5546 335.608 64.4808 333.802 64.7971 331.232C65.153 328.372 62.6222 326.251 60.2892 324.999C55.61 322.495 51.8403 322.692 49.5205 327.898V330.758Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.304 120.484C250.189 118.779 250.54 117.076 251.319 115.555C252.254 113.429 253.346 111.376 254.588 109.414C255.498 108.096 256.077 106.633 256.934 105.262C258.147 103.325 259.386 101.559 260.427 99.516C261.922 96.9682 263.69 94.5908 265.7 92.4256C266.982 90.9647 268.096 89.3643 269.021 87.6547C269.772 86.2314 270.906 85.1243 271.657 83.701C272.659 81.9613 273.331 79.9185 274.293 78.0998C275.237 76.1333 276.302 74.2274 277.483 72.3932C278.243 70.9946 279.222 69.7265 280.383 68.6372C281.251 67.7597 282.2 66.9655 283.217 66.2649C285.51 65.2633 286.683 66.054 287.87 68.1759C289.708 71.9139 290.552 76.0625 290.321 80.2217C290.141 84.5341 289.347 88.7987 287.962 92.8869C286.838 95.7283 285.452 98.4593 283.823 101.045C281.016 105.987 277.655 110.56 274.373 115.199C272.435 117.941 269.166 120.207 266.464 122.276C264.81 123.577 262.935 124.568 260.928 125.202C259.795 125.571 258.213 126.349 256.974 126.098C255.823 125.742 254.699 125.302 253.613 124.78C250.871 123.766 249.553 121.407 250.304 120.484Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.839 124.293C238.191 125.123 236.464 125.703 235.766 127.509C235.568 127.996 235.252 129.037 235.594 129.551C236.912 131.462 241.447 128.906 242.475 127.878C243.503 126.85 244.637 124.965 243.648 123.607C243.42 123.333 243.139 123.107 242.821 122.944C242.503 122.781 242.156 122.684 241.8 122.659C241.444 122.635 241.086 122.683 240.749 122.8C240.412 122.918 240.102 123.103 239.839 123.344V124.293Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.051 56.2618C322.944 56.7435 321.931 57.4172 321.059 58.2519C320.651 59.0091 320.341 59.8151 320.136 60.6505C319.018 63.6628 318.275 66.8009 317.922 69.9945C317.606 73.1312 317.513 78.6796 321.178 79.9712C328.295 82.4752 338.695 77.3354 339.275 69.362C339.604 64.8283 337.14 60.611 334.49 57.158C333.195 55.3208 331.671 53.6557 329.956 52.2026C329.36 51.7321 328.678 51.3839 327.947 51.1781C327.216 50.9723 326.452 50.9129 325.699 51.0033C323.234 51.5041 321.362 53.9555 324.051 56.2618Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.614 95.2723C322.614 93.7171 322.614 93.3349 323.642 92.3201C324.295 91.5949 325.083 91.004 325.962 90.5805C327.649 90.027 328.743 91.279 328.822 92.8737C328.888 94.0862 328.941 96.5507 327.847 97.3941C326.753 98.2376 322.324 97.4732 322.575 95.7467L322.614 95.2723Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.481 62.9173C373.756 65.8826 373.862 68.9402 373.295 71.9714C372.389 76.938 371.843 81.9636 371.66 87.0089C371.568 89.6447 371.66 92.1883 371.529 94.7846C371.179 97.9612 371.074 101.16 371.212 104.353C371.634 108.478 372.095 112.814 374.837 116.108C376.788 118.454 379.516 117.598 382.086 116.649C384.135 115.651 386.064 114.421 387.833 112.985C389.273 112.042 390.632 110.98 391.893 109.809C397.574 104.537 402.688 98.7252 404.968 91.0944C406.616 85.546 408.237 79.2332 406.88 73.5134C406.149 69.8543 404.503 66.44 402.095 63.5895C400.198 61.5169 397.926 59.8221 395.399 58.5945C393.303 57.4743 391.036 57.382 388.809 56.8549C386.94 56.4363 385.03 56.233 383.115 56.2486C381.344 56.2566 379.579 56.4331 377.842 56.7758C374.112 57.4743 373.189 62.4297 374.481 62.9173Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.188 124.767C380.847 122.698 382.337 120.563 384.775 121.696C385.642 122.089 386.322 122.805 386.669 123.691C387.016 124.577 387.003 125.564 386.633 126.441C386.293 127.087 385.74 127.597 385.068 127.885C384.396 128.173 383.646 128.222 382.943 128.022C382.022 127.638 381.224 127.009 380.636 126.204C379.779 125.057 380.478 124.161 380.636 122.856L380.188 124.767Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.858 175.665C384.974 175.843 383.116 176.236 381.322 176.838C381.153 177.26 380.917 177.652 380.623 177.998C380.241 178.499 379.107 179.158 379.305 179.883C381.704 180.897 385.131 179.276 387.214 178.156C388.311 177.623 389.334 176.949 390.258 176.153C390.853 175.63 391.395 175.052 391.88 174.426C392.644 173.043 391.88 172.318 390.469 172.331C389.059 172.344 385.606 173.438 385.474 175.191L386.858 175.665Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.837 167.586C465.887 169.203 465.519 170.805 464.77 172.239C464.098 173.939 463.149 175.955 463.452 177.853C464.111 182.347 470.319 181.451 473.482 181.042C477.199 180.555 480.732 179.724 483.513 177.089C485.559 175.392 486.868 172.969 487.164 170.328C487.823 165.557 488.93 157.491 481.892 157.583C478.964 157.78 476.155 158.814 473.799 160.562C472.179 161.705 470.751 163.097 469.568 164.687C467.933 166.598 466.127 168.193 465.837 167.586Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.356 426.333C418.413 419.665 421.629 413.998 427.732 410.215C429.155 409.332 430.368 408.186 432.068 409.069C433.465 409.807 433.202 411.428 432.767 412.812C431.928 414.954 430.729 416.938 429.221 418.676C427.792 420.289 426.274 421.82 424.674 423.263C423.769 424.252 422.625 424.991 421.352 425.411C419.65 425.47 417.967 425.781 416.356 426.333Z",
    fill: "#C4B0B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.172 433.99C174.291 431.434 175.767 430.234 177.783 428.547C182.281 425.061 187.403 422.466 192.875 420.904C197.542 419.441 203.104 418.413 207.941 419.744C210.103 420.35 212.805 421.391 213.728 423.605C215.309 427.427 211.197 433.055 208.152 435.163C204.316 437.799 198.767 438.616 194.378 439.947C190.283 441.17 185.98 441.533 181.738 441.015C180.211 440.927 178.701 440.648 177.243 440.185C175.86 439.843 174.496 439.43 173.157 438.946C171.971 438.313 170.429 437.325 170.323 435.915C170.289 435.068 170.489 434.229 170.903 433.49C171.654 432.277 173.236 432.119 174.172 433.99Z",
    fill: "#C4B0B8"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.943 150.401C457.388 151.442 454.435 152.918 454.989 155.264C455.337 156.309 455.742 157.334 456.202 158.335C456.495 159.26 456.685 160.215 456.769 161.181C456.937 162.77 457.544 164.28 458.522 165.544C459.233 166.321 459.985 165.544 460.472 164.793C461.077 164.033 461.46 163.121 461.58 162.157C461.598 160.915 461.744 159.679 462.014 158.467C462.146 157.992 462.502 157.57 462.608 157.149C462.719 156.478 462.746 155.796 462.687 155.119C462.644 154.037 462.259 152.997 461.586 152.149C460.913 151.3 459.987 150.688 458.943 150.401Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.084 284.209C433.808 284.354 433.478 284.459 433.333 284.749C433.267 284.909 433.227 285.078 433.214 285.25C433.149 286.001 434.19 286.331 434.704 286.476C435.451 286.715 436.24 286.796 437.021 286.715C437.801 286.633 438.556 286.39 439.238 286.001C439.742 285.695 440.177 285.287 440.515 284.804C440.853 284.321 441.087 283.773 441.202 283.194C441.203 282.472 441.001 281.764 440.619 281.151C440.237 280.538 439.69 280.045 439.04 279.728C438.497 279.331 437.857 279.087 437.188 279.02C436.518 278.952 435.843 279.065 435.231 279.346C434.783 279.611 434.431 280.013 434.229 280.493C434.084 280.888 434.111 281.31 433.992 281.705C433.873 282.1 433.478 282.628 433.557 283.207C433.612 283.592 433.798 283.946 434.084 284.209Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.56 286.753C442.552 286.596 442.585 286.441 442.657 286.302C442.729 286.163 442.836 286.046 442.968 285.962C443.076 285.838 443.225 285.757 443.387 285.735C443.55 285.713 443.715 285.752 443.851 285.843C443.973 285.933 444.075 286.046 444.153 286.175C444.231 286.305 444.282 286.448 444.304 286.598C444.326 286.747 444.319 286.9 444.282 287.046C444.245 287.192 444.179 287.33 444.089 287.451C443.949 287.594 443.776 287.7 443.585 287.76C443.394 287.82 443.191 287.831 442.995 287.794C442.786 287.734 442.604 287.605 442.48 287.427C442.355 287.25 442.295 287.035 442.309 286.819L442.56 286.753Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.399 255.109C462.889 255.153 462.416 255.394 462.081 255.782C461.96 255.875 461.865 255.998 461.805 256.139C461.745 256.28 461.722 256.433 461.738 256.586C461.883 257.551 462.381 258.429 463.135 259.05C463.379 259.237 463.663 259.365 463.965 259.424C464.267 259.484 464.578 259.473 464.875 259.393C465.412 259.154 465.906 258.829 466.338 258.431C466.75 258.136 467.141 257.814 467.511 257.469C467.883 257.226 468.177 256.883 468.359 256.479C468.541 256.075 468.604 255.627 468.539 255.189C468.442 254.755 468.231 254.355 467.927 254.031C467.624 253.706 467.239 253.469 466.813 253.343C466.233 253.238 465.636 253.292 465.086 253.502C464.401 253.686 463.913 253.686 463.399 255.109Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.51 257.89C459.929 258.045 460.308 258.292 460.617 258.615C460.538 258.826 460.749 259.01 460.617 259.235C460.485 259.459 459.892 259.314 459.655 259.235C459.33 259.116 459.065 258.875 458.917 258.562C458.917 258.444 458.627 257.93 458.917 257.983L459.51 257.89Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.219 275.023C412.797 275.498 412.323 276.012 412.626 276.75C412.799 277.026 413.056 277.24 413.36 277.359C413.664 277.478 413.998 277.495 414.313 277.409C414.643 277.409 415.012 277.277 415.157 276.921C415.302 276.565 415.354 276.13 415.473 275.761C415.75 274.865 416.791 274.443 416.264 273.376C416.146 273.138 415.976 272.93 415.766 272.767C415.556 272.605 415.311 272.493 415.051 272.44C414.194 272.44 413.522 273.231 413.021 273.929L413.219 275.023Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.646 364.483C287.909 363.917 288.225 362.876 289.201 362.52C289.79 362.314 290.431 362.314 291.02 362.52C292.483 362.757 293.933 363.218 292.971 364.668C292.287 365.455 291.358 365.989 290.334 366.184C289.464 366.329 287.856 366.052 287.935 365.314L287.646 364.483Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.089 57.1844C375.759 58.5023 375.311 60.1497 376.813 61.1382C377.842 61.7708 379.45 61.1382 380.306 60.4397C381.782 59.0987 382.789 57.3205 383.18 55.3657C383.404 53.6392 381.321 51.7941 379.74 51.5965C376.51 51.2011 374.784 56.3278 374.599 58.7396L376.089 57.1844Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.892 347.93C367.906 349.435 367.529 351.258 367.837 353.031C367.969 354.098 367.982 355.535 369.379 355.891C372.675 356.721 376.089 350.619 376.972 348.603C377.737 347.02 378.095 345.271 378.013 343.515C377.921 342.553 377.209 340.669 376.062 340.273C375.26 340.126 374.433 340.189 373.662 340.454C372.891 340.72 372.202 341.179 371.66 341.789C369.182 344.267 369.366 347.127 368.022 349.802L368.892 347.93Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.165 347.706C366.305 347.833 365.46 348.054 364.648 348.365C364.239 348.603 363.593 348.972 363.448 349.354C363.303 349.736 363.607 350.329 364.002 350.672C364.171 350.794 364.367 350.875 364.573 350.907C364.779 350.939 364.99 350.922 365.188 350.856C365.51 350.666 365.795 350.421 366.032 350.131C366.41 349.727 366.746 349.286 367.034 348.813C367.202 348.608 367.343 348.382 367.455 348.141C367.574 347.772 367.297 347.68 367.218 347.403L367.165 347.706Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.396 362.335L364.503 362.665C364.384 363.034 364.503 363.442 364.028 363.719C363.562 363.914 363.053 363.982 362.552 363.917C362.064 363.811 361.787 363.535 361.853 363.113C361.919 362.691 362.526 362.375 363.092 362.23L363.396 362.335Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.614 374.645C307.614 375.04 307.614 375.317 308.062 375.488C308.441 375.606 308.844 375.624 309.232 375.541C309.62 375.458 309.98 375.276 310.277 375.014C311.081 374.262 311.793 372.879 311.292 372.127C311.008 371.838 310.632 371.655 310.229 371.609C309.826 371.563 309.419 371.658 309.077 371.877C308.677 372.16 308.306 372.482 307.97 372.839C307.789 373.082 307.662 373.36 307.596 373.655C307.53 373.95 307.527 374.256 307.588 374.552L307.614 374.645Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.959 279.61C248.564 279.965 248.366 280.084 248.274 280.585C248.194 280.853 248.167 281.134 248.197 281.413C248.226 281.691 248.311 281.961 248.445 282.206C249.306 283.226 250.494 283.915 251.807 284.156C252.268 284.289 252.754 284.311 253.225 284.222C253.697 284.133 254.141 283.934 254.522 283.642C254.993 283.335 255.394 282.93 255.696 282.454C255.998 281.979 256.196 281.445 256.275 280.888C256.417 280.345 256.382 279.772 256.176 279.25C255.97 278.729 255.603 278.287 255.128 277.988C254.223 277.295 253.18 276.801 252.07 276.539C251.642 276.462 251.203 276.489 250.787 276.617C250.372 276.746 249.994 276.972 249.684 277.277C249.025 277.83 248.155 278.832 248.959 279.61Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.606 283.471C257.606 283.155 257.606 282.773 257.923 282.68C258.213 282.676 258.501 282.729 258.771 282.838C259.04 282.947 259.285 283.108 259.491 283.313C259.781 283.65 259.94 284.081 259.939 284.525C259.844 284.82 259.648 285.072 259.386 285.237C259.206 285.394 258.98 285.488 258.742 285.505C258.504 285.521 258.267 285.46 258.068 285.329C257.791 285.158 257.119 284.802 257.224 284.394L257.606 283.471Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1473 249.732C89.6728 246.371 88.4596 242.247 88.7203 238.082C88.8125 236.303 88.6149 233.087 91.1456 233.337C94.5462 233.667 96.2861 238.939 97.2351 241.574C98.6455 245.528 100.016 249.482 99.5154 253.712C98.83 259.498 91.2115 247.979 90.4601 246.912L92.1473 249.732Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.4759 230.609C98.8696 233.97 100.372 238.741 104.01 239.835C105.328 240.217 105.789 239.413 106.475 238.187C106.863 237.615 107.121 236.964 107.23 236.281C107.339 235.598 107.298 234.899 107.108 234.234C106.689 233.338 106.162 232.497 105.539 231.73C105.181 231.292 104.867 230.82 104.603 230.319C104.353 229.779 104.445 229.357 104.023 228.883C103.008 227.736 99.0804 226.801 99.4759 229.476V230.609Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.541 468.955C137.34 466.825 138.794 465.003 140.692 463.749C142.862 462.287 145.271 461.217 147.81 460.586C150.214 460.032 152.729 460.225 155.02 461.14C157.248 462.326 159.225 464.092 161.334 465.462C163.245 466.714 165.169 467.413 166.843 469.074C168.341 470.611 169.495 472.448 170.231 474.464C171.391 477.521 172.234 482.213 170.929 485.323C169.743 488.157 168.069 488.197 165.235 488.144C161.281 488.078 157.419 484.836 154.915 481.936C153.793 480.416 152.526 479.008 151.132 477.732C149.326 476.309 147.441 474.991 145.543 473.699C143.682 472.671 141.882 471.535 140.152 470.299C139.427 469.667 137.081 467.874 136.541 468.955Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.054 289.27C204.804 290.72 204.435 291.352 205.502 292.064C205.831 292.299 206.225 292.425 206.629 292.425C207.034 292.425 207.428 292.299 207.756 292.064C208.56 291.589 210.393 289.876 210.116 288.861C209.641 286.739 204.316 286.66 204.593 289.23L205.054 289.27Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.82 357.34C303.963 353.387 307.996 347.627 312.557 344.398C319.055 339.786 328.928 338.784 336.203 339.759C342.306 340.563 347.315 343.792 348.541 348.168C348.87 349.341 348.646 350.566 348.923 351.739C349.147 352.635 349.384 353.149 348.066 353.901C344.784 355.759 339.591 356.905 335.9 357.512C331.788 358.327 327.61 358.769 323.418 358.83C319.885 358.751 316.511 358.237 312.979 358.105C311.295 358.111 309.614 357.965 307.957 357.67C307.126 357.512 305.057 357.802 304.82 357.34Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.286 332.972C338.892 333.723 338.919 334.158 340.118 334.29C341.053 334.283 341.966 334.014 342.754 333.512C343.717 332.959 345.048 331.641 344.573 330.877C343.73 329.44 337.983 330.297 338.576 332.195L338.286 332.972Z",
    fill: "#C4B0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.575 256.533C428.754 255.445 429.153 254.404 429.748 253.475C430.027 253.292 430.34 253.166 430.668 253.105C430.996 253.044 431.333 253.049 431.659 253.119C432.261 253.156 432.846 253.332 433.367 253.634C433.889 253.936 434.333 254.355 434.664 254.859C435.239 255.401 435.689 256.063 435.982 256.796C436.892 260.948 429.576 259.155 428.614 256.533H428.575Z",
    fill: "#C4B0FF"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M454.916 528.005C513.733 490.351 546.665 436.794 528.472 408.382C510.278 379.97 447.849 387.462 389.031 425.116C330.214 462.77 297.282 516.327 315.475 544.739C333.669 573.151 396.098 565.659 454.916 528.005Z",
    fill: "url(#paint2_radial_110_3490)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M582.013 432.573C592.767 431.051 603.597 426.454 614.479 416.869C638.747 395.496 634.117 358.896 615.91 337.106C597.299 314.903 559.522 301.761 514.289 337.817C437.675 398.888 405.796 376.632 405.485 376.386L399.921 383.576C401.398 384.747 436.935 411.107 520.013 344.913C560.095 313.022 592.256 322.944 608.993 342.928C624.459 361.436 628.679 392.313 608.531 410.04C583.525 432.041 558.609 423.591 532.232 414.659C521.621 411.055 510.65 407.337 499.594 405.66C460.111 399.672 435.489 423.22 434.458 424.221L440.814 430.718C448.669 424.072 457.863 419.197 467.772 416.425C477.68 413.653 488.069 413.05 498.232 414.656C508.482 416.199 519.077 419.791 529.324 423.266C546.505 429.127 564.157 435.1 582.013 432.573Z",
    fill: "#CAB3DA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M525.546 517.354C525.546 517.354 548.173 537.608 565.317 527.716L525.546 517.354Z",
    fill: "#CAB3DA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.762 349.467C221.744 366.134 264.83 381.877 286.738 375.52C287.716 375.241 288.678 374.906 289.618 374.519C302.545 369.046 310.458 353.783 314.352 343.862C315.541 340.931 316.554 337.931 317.385 334.878L311.77 290.138C311.77 290.138 311.203 290.329 310.238 290.728C304.498 293.065 299.055 296.078 294.026 299.701C285.701 305.902 255.65 316.545 239.113 315.229C222.576 313.913 216.105 309.627 212.33 310.741C208.555 311.855 206.431 318.779 206.431 318.779C206.431 318.779 203.294 331.904 212.762 349.467Z",
    fill: "url(#paint3_radial_110_3490)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.431 318.779C206.431 318.779 212.84 315.319 216.141 319.143C219.442 322.967 226.63 348.015 212.773 349.452C198.916 350.889 206.444 318.777 206.444 318.777L206.431 318.779Z",
    fill: "#684D73"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.151 319.812C210.151 319.812 214.241 333.21 208.05 345.912C208.05 345.912 198.966 329.991 210.151 319.812Z",
    fill: "#53345F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.826 323.256C182.858 330.524 189.889 336.176 198.068 339.529C201.652 341.122 205.411 342.29 209.267 343.008C211.914 337.458 212.582 331.17 211.16 325.188C211.16 325.188 210.22 323.61 208.669 321.332C205.198 316.304 199.043 307.82 194.214 305.289L194.784 311.652C194.784 311.652 188.405 303.434 174.662 305.973C174.676 305.971 168.171 308.658 177.826 323.256Z",
    fill: "#D9D9D9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M256.825 313.632C256.825 313.632 266.401 323.867 270.651 347.551C274.9 371.234 258.878 375.117 258.878 375.117C258.878 375.117 268.962 377.539 275.919 376.968C275.919 376.968 313.16 361.955 271.456 309.767L256.825 313.632Z",
    fill: "url(#paint4_linear_110_3490)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.352 343.862C315.414 347.272 316.712 350.786 318.089 354.469L328.305 328.186L314.352 289.469L310.326 290.274C310.278 290.419 310.256 290.56 310.21 290.718C304.469 293.056 299.027 296.068 293.998 299.691C293.998 299.691 328.114 324.887 289.605 374.424C302.546 369.046 310.458 353.783 314.352 343.862Z",
    fill: "url(#paint5_linear_110_3490)"
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.587 554.764C364.587 554.764 370.341 539.172 408.128 537.562C408.133 537.603 396.103 557.892 364.587 554.764Z",
    fill: "#311745"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528.776 477.199C528.776 477.199 504.806 480.592 496.299 509.393C496.299 509.393 507.31 512.222 519.242 502.737C531.173 493.252 528.776 477.199 528.776 477.199Z",
    fill: "#311745"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.296 559.853L408.717 550.988C408.717 550.988 407.813 546.548 406.628 539.445C403.59 521.495 398.702 486.67 401.71 464.25L332.806 434.458C332.806 434.458 333.125 438.759 333.711 445.534C335.516 465.203 333.93 505.567 340.374 520.578C349.059 540.695 392.296 559.853 392.296 559.853Z",
    fill: "url(#paint6_radial_110_3490)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.802 434.431C351.132 451.197 374.198 461.884 398.84 465.029L401.71 464.25L417.039 460.052C417.035 460.002 417.028 459.952 417.018 459.903L416.974 459.592C416.956 459.511 416.944 459.43 416.939 459.348C416.918 459.245 416.903 459.142 416.895 459.037C416.046 452.065 412.02 408.121 438.469 365.218C434.664 361.887 431.087 358.304 427.762 354.494C427.104 353.746 426.398 352.949 425.645 352.117C422.232 348.281 418.098 343.444 413.202 337.321C402.499 324.099 384.643 302.645 372.346 287.911C368.656 283.479 365.452 279.656 363.088 276.803C362.207 275.741 361.425 274.803 360.783 274.066L358.821 271.708C358.821 271.708 329.132 291.627 310.814 288.356C310.814 288.356 310.612 288.978 310.315 290.193C310.268 290.351 310.247 290.492 310.198 290.637C308.726 296.999 305.691 316.112 314.308 343.744C315.384 347.152 316.668 350.668 318.056 354.335C318.572 355.642 319.089 356.949 319.659 358.248C319.726 380.505 322.948 402.641 329.228 423.994C330.342 427.576 331.518 431.011 332.802 434.431Z",
    fill: "#CAB3DA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.717 315.913C376.459 316.871 377.258 317.834 378.076 318.836C390.968 334.369 409.533 348.741 427.8 354.572C438.996 358.12 450.037 358.434 459.586 353.853C480.912 343.576 487.791 323.74 489.377 317.983C489.414 317.799 489.462 317.617 489.52 317.438C489.545 317.278 489.583 317.121 489.633 316.967C489.73 316.58 489.771 316.382 489.771 316.382C489.771 316.382 496.295 310.422 492.304 302.597C488.313 294.773 479.172 284.104 479.172 284.104L474.776 284.533C474.776 284.533 471.287 279.383 465.285 280.357C459.282 281.331 447.18 288.439 428.154 286.993C411.42 285.746 385.683 279.386 376.967 276.301C376.051 276.023 375.163 275.659 374.316 275.214C371.356 273.667 368.133 272.686 364.813 272.323L362.422 273.461L360.844 274.209L355.998 276.523C355.998 276.523 354.648 289.505 375.717 315.913Z",
    fill: "url(#paint7_radial_110_3490)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.038 460.052C417.038 460.052 456.896 486.035 466.592 493.218C476.287 500.4 503.049 509.32 516.196 509.294C516.516 509.305 516.838 509.296 517.158 509.269C529.512 508.817 533.407 500.069 533.407 500.069C533.407 500.069 532.734 497.653 531.657 493.846C530.208 488.78 528.044 481.29 525.693 473.841C522.606 463.929 519.209 454.061 516.93 450.244C513.053 443.714 472.075 400.462 450.947 378.312C443.466 370.499 438.482 365.312 438.482 365.312C407.72 396.27 415.571 451.345 416.906 459.118C416.914 459.223 416.929 459.327 416.95 459.429C416.956 459.511 416.968 459.593 416.985 459.673L417.023 459.943C417.03 459.979 417.035 460.015 417.038 460.052Z",
    fill: "url(#paint8_radial_110_3490)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.272 277.64C353.272 277.64 338.871 292.097 332.63 294.995C326.39 297.893 310.86 288.487 310.86 288.487C310.86 288.487 326.499 288.329 353.272 277.64Z",
    fill: "#53345F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.798 272.311C364.798 272.311 371.961 324.959 418.325 351.774C418.325 351.774 377.206 334.234 353.272 277.64L364.798 272.311Z",
    fill: "#53345F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.346 289.525C314.346 289.525 312.561 330.138 319.695 358.408C319.695 358.408 304.036 328.199 306.427 292.454L310.86 288.487L314.346 289.525Z",
    fill: "#53345F"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.146 373.252C446.146 373.252 424.72 393.836 423.511 464.254L417.079 460.046C417.079 460.046 404.132 393.632 438.505 365.282L446.146 373.252Z",
    fill: "#53345F"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.299 424.205C329.299 424.205 365.794 462.504 401.695 464.238L401.223 468.61C401.223 468.61 365.193 471.806 333.451 442.328L329.299 424.205Z",
    fill: "#53345F"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M489.781 316.352C489.781 316.352 496.306 310.392 492.314 302.568C488.323 294.744 479.182 284.075 479.182 284.075L474.786 284.504C474.786 284.504 463.112 307.116 489.781 316.352Z",
    fill: "#684D73"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.823 308.699C490.823 308.699 474.542 297.205 479.136 284.136C479.182 284.075 495.456 302.441 490.823 308.699Z",
    fill: "#53345F"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.245 293.297C479.245 293.297 476.758 281.478 485.365 274.244L488.018 279.14C488.018 279.14 497.753 264.377 511.298 268.145C511.298 268.145 516.356 291.589 488.624 307.009C484.046 303.621 480.743 298.791 479.245 293.297Z",
    fill: "#D9D9D9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M504.774 435.724C504.774 435.724 512.775 451.012 495.066 470.077C477.357 489.141 457.828 487.063 457.828 487.063C457.828 487.063 468.554 495.286 475.637 498.34C482.72 501.394 513.796 483.666 521.641 461.402C521.641 461.402 519.17 452.714 515.85 448.658C512.53 444.603 504.774 435.724 504.774 435.724Z",
    fill: "url(#paint9_linear_110_3490)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M401.07 491.702C401.07 491.702 390.046 508.082 374.495 518.411C365.197 524.57 353.959 527.094 342.921 525.502C342.921 525.502 350.355 535.419 358.388 540.216C358.388 540.216 378.406 536.002 387.843 528.002C397.28 520.001 402.262 507.333 402.262 507.333L401.07 491.702Z",
    fill: "url(#paint10_linear_110_3490)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M423.203 286.521C423.203 286.521 400.964 327.973 444.94 357.223C439.526 357.44 434.119 356.653 428.992 354.9C416.957 351.084 380.356 305.211 409.789 284.266L423.203 286.521Z",
    fill: "url(#paint11_linear_110_3490)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M401.449 464.549L401.948 463.982C401.649 463.72 372.158 437.373 359.929 414.736C349.339 395.096 347.049 383.885 343.884 368.355C342.694 362.48 341.338 355.828 339.343 347.969C335.067 331.067 332.034 313.875 330.268 296.53L329.51 296.638C331.291 314.022 334.335 331.253 338.616 348.196C340.594 356.029 341.95 362.682 343.152 368.541C346.326 384.139 348.618 395.364 359.268 415.133C371.56 437.83 401.078 464.27 401.449 464.549Z",
    fill: "#53345F"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.296 540.171L406.574 539.452C403.536 521.503 398.648 486.678 401.656 464.257L417.039 460.052C417.039 460.052 456.896 486.035 466.606 493.216C476.315 500.396 503.05 509.32 516.196 509.294C516.517 509.3 516.837 509.286 517.156 509.255L531.648 493.778C530.215 488.724 528.037 481.236 525.699 473.785L524.128 473.607C524.128 473.607 510.159 496.282 490.111 497.947C470.064 499.612 429.865 458.057 429.086 449.433C426.192 417.195 441.889 390.647 450.944 378.285L438.477 365.272C434.672 361.941 431.095 358.358 427.769 354.549C438.965 358.097 450.007 358.41 459.567 353.814C480.88 343.539 487.76 323.717 489.344 317.946C487.452 324.078 478.545 346.74 445.727 353.717C439.03 355.096 432.078 354.539 425.686 352.111C397.188 341.947 375.807 301.15 373.178 292.126C372.775 290.767 372.513 289.371 372.395 287.959C371.777 279.892 376.936 276.277 376.936 276.277C376.035 275.996 375.158 275.64 374.316 275.213C371.356 273.667 368.133 272.686 364.814 272.322L362.422 273.461C362.614 274.331 362.839 275.527 363.15 276.946C366.075 290.32 370.289 303.378 375.734 315.938C379.926 325.815 385.442 335.075 392.132 343.463C414.566 370.547 421.159 374.623 421.159 374.623C421.159 374.623 414.629 425.966 402.948 440.148C391.268 454.331 351.047 440.596 340.184 432.378C335.014 428.515 331.544 425.833 329.274 424.126C330.34 427.563 331.503 430.999 332.8 434.417C332.8 434.417 333.119 438.718 333.706 445.493C344.598 454.203 381.604 484.509 389.746 497.776C399.3 513.409 405.296 540.171 405.296 540.171Z",
    fill: "url(#paint12_linear_110_3490)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.796 272.297C364.796 272.297 362.09 301.919 338.194 322.895C314.298 343.87 299.139 296.245 299.139 296.245L306.426 292.454L310.361 290.324L364.796 272.297Z",
    fill: "#53345F"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.484 267.93C224.719 268.227 224.939 268.514 225.199 268.794C228.5 272.618 234.214 276.528 241.442 279.921C241.442 279.921 241.873 280.136 242.691 280.461C258.519 287.381 275.693 290.678 292.959 290.111C322.974 288.966 365.895 278.406 390.347 253.654C414.799 228.902 415.384 168.7 404.508 151.529C400.774 145.546 396.675 139.799 392.234 134.321C377.834 116.614 354.348 95.9437 320.465 94.034C294.857 92.5813 262.289 101.427 238.395 113.254C231.596 116.536 225.124 120.456 219.065 124.96C215.823 127.367 212.863 130.133 210.242 133.204L209.334 134.395C208.73 135.173 208.182 135.993 207.695 136.849C182.507 181.064 208.429 247.214 224.484 267.93Z",
    fill: "url(#paint13_linear_110_3490)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M227.891 262.949C228.122 263.22 228.313 263.496 228.556 263.752C235.963 269.188 260.665 282.567 296.626 268.356C340.848 250.892 340.986 210.54 340.986 210.54L349.706 207.705C348.625 201.924 347.896 196.577 347.433 191.648C344.792 164.025 350.433 149.676 349.568 145.811C348.556 141.194 333.727 116.566 298.852 110.671C275.742 106.781 255.196 112.049 240.934 117.931C234.556 121.004 228.487 124.682 222.812 128.913C219.764 131.159 216.986 133.752 214.537 136.639L213.687 137.753C213.117 138.484 212.604 139.258 212.152 140.068C202.336 157.284 200.801 178.019 203.418 197.78C207.097 225.615 219.077 251.571 227.891 262.949Z",
    fill: "url(#paint14_linear_110_3490)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.692 280.461C258.52 287.381 275.694 290.678 292.959 290.111C322.974 288.966 365.896 278.406 390.347 253.654C414.799 228.902 415.384 168.7 404.509 151.529C400.775 145.546 396.676 139.799 392.235 134.321C387.629 131.027 382.431 129.5 376.601 131.594C355.213 139.286 361.827 211.84 361.827 211.84L350.924 212.803C350.924 212.803 351.151 255.049 309.927 276.242C273.916 294.779 248.441 282.766 242.692 280.461Z",
    fill: "url(#paint15_linear_110_3490)"
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.449 238.95C391.399 250.069 371.576 249.426 363.227 213.159C354.879 176.892 369.526 137.757 369.526 137.757C339.691 146.119 354.356 209.075 354.356 209.075C355.389 211.688 356.379 214.101 357.402 216.357L357.506 216.604C378.893 264.465 398.75 241.081 400.449 238.95Z",
    fill: "url(#paint16_linear_110_3490)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.915 156.542C401.7 144.558 392.488 137.376 385.372 138.77C378.256 140.164 364.495 175.324 374.607 210.886C384.718 246.448 405.804 230.962 408.135 216.433L409.606 208.498C409.606 208.498 395.828 234.278 383.027 213.64C368.41 190.114 383.858 154.397 395.367 156.935C406.875 159.473 411.03 179.858 411.03 179.858C411.03 179.858 410.387 164.495 406.915 156.542Z",
    fill: "#53345F"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.506 554.504L410.144 550.247L408.201 537.593C408.201 537.593 383.835 553.985 364.646 554.798C372.464 559.778 381.487 562.54 390.753 562.789C390.753 562.789 376.998 572.16 380.278 587.922L413.506 554.504Z",
    fill: "#D9D9D9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.387 509.339L522.975 512.64L525.556 517.421C525.556 517.421 543.269 531.72 565.325 527.77C565.325 527.77 558.823 509.718 536.142 503.794L528.795 477.237C527.563 485.077 524.332 492.468 519.414 498.697C511.6 508.51 497.622 509.288 496.387 509.339Z",
    fill: "#D9D9D9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.506 554.504L416.441 556.324L382.093 590.122L380.231 587.888L413.506 554.504Z",
    fill: "#CAB3DA"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.587 554.765C372.404 559.745 381.427 562.507 390.693 562.756C390.693 562.756 406.223 555.494 413.506 554.504L410.144 550.247L408.201 537.593C408.201 537.593 383.779 553.98 364.587 554.765Z",
    fill: "url(#paint17_linear_110_3490)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.388 509.339L522.975 512.64C528.007 510.783 532.521 507.75 536.142 503.794L528.795 477.237C527.563 485.077 524.332 492.468 519.415 498.697C511.6 508.51 497.622 509.288 496.388 509.339Z",
    fill: "url(#paint18_linear_110_3490)"
  }), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M333.909 147.973C333.909 147.973 331.999 137.204 330.351 134.14C325.131 131.09 319.363 129.093 313.375 128.264L310.126 148.4C310.126 148.4 328.603 147.234 333.909 147.973Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M227.967 263.587C228.185 263.859 228.389 264.134 228.633 264.389C236.026 269.828 260.697 283.183 296.62 268.992C340.787 251.535 340.879 211.245 340.879 211.245L349.571 208.414C348.504 202.632 347.777 197.298 347.3 192.371C347.3 192.371 261.2 131.165 203.524 198.428C207.192 226.292 219.156 252.222 227.967 263.587Z",
    fill: "url(#paint19_linear_110_3490)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M334.393 219.035C334.393 219.035 333.542 228.621 330.222 234.803L324.398 232.647C324.398 232.647 327.134 223.705 328.108 218.406L334.393 219.035Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.768 286.137C508.768 286.137 501.21 297.28 491.986 299.082C482.762 300.885 479.01 291.633 479.01 291.633C479.01 291.633 479.065 299.628 488.57 307.017C488.57 307.017 504.327 298.632 508.768 286.137Z",
    fill: "url(#paint20_linear_110_3490)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.081 339.527C201.666 341.12 205.425 342.288 209.281 343.006C211.928 337.456 212.596 331.168 211.174 325.186C211.174 325.186 210.233 323.608 208.683 321.33C208.683 321.33 210.504 331.27 198.081 339.527Z",
    fill: "url(#paint21_linear_110_3490)"
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.918 335.151C348.845 336.872 350.103 338.393 351.62 339.627C353.136 340.861 354.881 341.783 356.755 342.341C358.629 342.898 360.594 343.081 362.539 342.877C364.483 342.674 366.368 342.088 368.085 341.154C369.808 340.229 371.33 338.971 372.565 337.455C373.8 335.939 374.723 334.193 375.281 332.319C375.839 330.445 376.021 328.479 375.816 326.534C375.612 324.589 375.025 322.704 374.089 320.987C373.162 319.266 371.904 317.745 370.388 316.511C368.871 315.277 367.126 314.355 365.252 313.797C363.378 313.239 361.413 313.057 359.469 313.26C357.524 313.464 355.639 314.049 353.922 314.983C352.201 315.91 350.68 317.168 349.446 318.685C348.212 320.201 347.29 321.946 346.732 323.82C346.174 325.694 345.992 327.659 346.195 329.604C346.399 331.548 346.984 333.433 347.918 335.151Z",
    fill: "#684D73"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.777 332.531C353.958 334.7 355.952 336.311 358.32 337.01C360.688 337.71 363.237 337.441 365.406 336.263C366.482 335.679 367.431 334.889 368.2 333.939C368.97 332.988 369.545 331.895 369.891 330.722C370.238 329.549 370.35 328.319 370.22 327.103C370.091 325.886 369.723 324.707 369.138 323.633C367.957 321.465 365.964 319.854 363.596 319.154C361.227 318.454 358.679 318.723 356.509 319.902C354.34 321.083 352.729 323.076 352.029 325.444C351.33 327.812 351.599 330.361 352.777 332.531Z",
    fill: "url(#paint22_linear_110_3490)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.726 283.248C403.726 283.248 392.186 300.667 379.488 277.144C379.488 277.144 397.02 281.783 403.726 283.248Z",
    fill: "#684D73"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M371.19 487.074C381.231 485.583 391.157 483.404 400.899 480.55L400.672 479.823C400.183 479.975 351.772 494.458 335.466 483.369L335.044 483.994C342.901 489.395 357.663 488.988 371.19 487.074Z",
    fill: "#53345F"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M437.51 474.829L438.267 474.722C436.444 465.867 436.005 456.782 436.966 447.793C439.529 424.856 464.777 393.354 465.023 393.043L464.43 392.561C464.185 392.872 438.795 424.546 436.209 447.707C435.246 456.761 435.685 465.909 437.51 474.829Z",
    fill: "#53345F"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M477.805 339.559L478.401 339.088C446.557 298.558 465.364 280.815 465.548 280.651L465.054 280.086C464.845 280.267 460.009 284.705 459.147 294.306C458.297 303.12 460.961 318.141 477.805 339.559Z",
    fill: "#53345F"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M241.459 369.911C255.993 340.795 223.863 312.765 223.548 312.493L223.049 313.06C223.365 313.346 255.055 340.997 240.789 369.564L241.459 369.911Z",
    fill: "#53345F"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M378.113 368.808C379.779 371.75 381.814 374.467 384.17 376.892L390.008 372.906C388.298 369.867 385.731 367.399 382.628 365.809L378.113 368.808Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M452.532 287.254C450.297 288.31 447.841 288.814 445.371 288.722L443.226 292.283C443.226 292.283 448.977 294.601 452.324 291.146L452.532 287.254Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M491.641 441.198C494.578 442.966 497.042 445.42 498.821 448.351L495.098 452.755L488.606 445.395L491.641 441.198Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M213.422 311.042C215.836 311.878 217.924 313.457 219.386 315.552L224.263 315.786C223.244 314.663 222.093 313.668 220.835 312.822C218.878 311.567 213.422 311.042 213.422 311.042Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M343.913 496.84C343.913 496.84 342.868 508.952 344.905 514.376L339.871 514.978C337.962 509.542 337.385 503.728 338.189 498.023L343.913 496.84Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M316.974 107.292C316.974 107.292 287.405 100.963 269.533 104.155C269.533 104.155 331.854 86.6679 316.974 107.292Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M362.711 164.869L351.667 163.562L350.767 175.529L361.289 175.874L362.711 164.869Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_110_3490)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M624.797 111.23L664.56 131.181L671.863 114.231L634.457 93.6686C634.457 93.6686 626.525 105.997 624.797 111.23Z",
    fill: "url(#paint23_linear_110_3490)"
  }), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.133 76.4162L620.55 68.9694C620.55 68.9694 633.603 74.5939 643.142 90.2453L642.796 90.8868L624.403 80.3206L623.628 81.6526L618.133 76.4162Z",
    fill: "url(#paint24_linear_110_3490)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M601.491 107.401L596.469 113.682C596.469 113.682 608.352 121.479 626.668 120.829L627.014 120.187L608.075 110.669L608.76 109.288L601.491 107.401Z",
    fill: "url(#paint25_linear_110_3490)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M537.364 52.9408C532.637 61.7205 546.146 86.7264 566.211 96.0968C586.275 105.467 619.726 111.788 619.726 111.788L625.892 100.6L631.837 89.2945C631.837 89.2945 608.127 64.8473 589.275 53.2578C570.423 41.6683 542.059 44.2204 537.364 52.9408Z",
    fill: "url(#paint26_radial_110_3490)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M619.73 111.794C619.73 111.794 625.492 98.3843 631.841 89.3004C631.841 89.3004 626.309 102.527 619.73 111.794Z",
    fill: "#31165F"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M539.821 69.4778C539.821 69.4778 542.619 54.9463 553.903 45.7533C553.903 45.7533 540.85 46.6018 537.364 52.9407C534.227 58.6441 539.821 69.4778 539.821 69.4778Z",
    fill: "url(#paint27_radial_110_3490)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M554.014 45.893C543.412 54.36 540.037 69.3493 539.996 69.5132L539.649 69.4396C539.679 69.2883 543.089 54.1607 553.796 45.615L554.014 45.893Z",
    fill: "#53345F"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.459 56.2662L540.327 49.8671C540.327 49.8671 536.182 51.9329 536.459 56.2662Z",
    fill: "#53345F"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.641 55.1834C537.105 53.8551 537.742 52.594 538.537 51.4327C538.537 51.4327 535.056 50.4917 534.341 51.5614C533.627 52.631 536.641 55.1834 536.641 55.1834Z",
    fill: "url(#paint28_linear_110_3490)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.036 106.824C598.036 106.824 602.101 84.5365 614.161 72.4951C621.281 78.7414 631.839 89.3032 631.839 89.3032C631.839 89.3032 626.016 97.2557 619.729 111.796C619.731 111.794 608.466 110.234 598.036 106.824Z",
    fill: "url(#paint29_radial_110_3490)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M551.035 61.249C547.385 69.4899 553.676 80.1666 561.623 84.9115C569.569 89.6564 578.598 84.8077 582.696 76.655C586.794 68.5024 584.922 58.8999 575.504 55.0323C566.998 51.5241 555.091 52.09 551.035 61.249Z",
    fill: "url(#paint30_radial_110_3490)"
  }), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M549.738 60.5507C546.088 68.7916 552.379 79.4684 560.325 84.2132C568.272 88.9581 577.301 84.1094 581.402 75.9583C585.502 67.8072 583.627 58.2031 574.207 54.3341C565.704 50.8273 553.797 51.3933 549.738 60.5507Z",
    fill: "#31165F"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548.834 60.0638C545.184 68.3046 551.475 78.9814 559.421 83.7263C567.367 88.4712 576.397 83.6224 580.497 75.4713C584.598 67.3203 582.723 57.7162 573.303 53.8471C564.799 50.3404 552.893 50.9063 548.834 60.0638Z",
    fill: "url(#paint31_radial_110_3490)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M552.022 61.1023C548.629 68.4319 554.045 75.9405 560.258 79.6536C566.471 83.3667 573.528 79.5338 576.75 73.1295C579.972 66.7252 578.524 59.206 571.176 56.1794C564.512 53.4334 555.553 53.4394 552.022 61.1023Z",
    fill: "#A6345F"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578.027 65.2476C578.355 67.9396 577.858 70.6678 576.6 73.0704C573.534 79.1649 566.137 83.147 560.233 79.6184C558.212 78.4138 556.436 76.8392 554.998 74.977C552.168 71.3031 550.904 66.5364 553.073 61.628C556.256 54.361 564.974 54.3347 571.3 56.9384C575.36 58.6321 577.521 61.7531 578.027 65.2476Z",
    fill: "url(#paint32_linear_110_3490)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M581.415 75.94L581.33 76.0983L603.942 88.2725L604.027 88.1143L581.415 75.94Z",
    fill: "#53345F"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M598.111 106.835L597.937 106.799C603.409 81.7417 613.983 72.52 614.087 72.4298L614.203 72.5654C614.107 72.663 603.582 81.8532 598.111 106.835Z",
    fill: "#53345F"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M589.665 104.486L589.488 104.503C589.478 104.414 588.788 95.3784 594.563 83.1282L594.718 83.2119C588.953 95.4093 589.658 104.398 589.665 104.486Z",
    fill: "#53345F"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M621.659 94.3339L611.731 89.3969L612.509 86.3347L622.798 92.2173L621.659 94.3339Z",
    fill: "#31165F"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.929 110.041C620.929 110.041 625.259 99.7715 631.256 90.6511L635.309 93.5953L625.016 111.563L620.929 110.041Z",
    fill: "url(#paint33_radial_110_3490)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M622.997 110.804C623.138 107.788 623.982 104.846 625.461 102.213C627.913 97.876 634.375 92.9066 634.375 92.9066L631.256 90.6511C631.256 90.6511 624.631 100.545 620.929 110.041L622.997 110.804Z",
    fill: "#31165F"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M558.091 58.7314C560.043 58.1324 562.08 57.8574 564.121 57.9174L564.069 55.9213C564.069 55.9213 560.65 55.5896 558.489 57.2473L558.091 58.7314Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M563.405 78.4938L566.279 78.4156L566.335 80.0715L564.013 79.9912L563.405 78.4938Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.403 74.148C542.403 74.148 542.753 58.299 557.797 45.4949L553.903 45.7533C553.903 45.7533 544.533 52.7729 539.821 69.4779L542.403 74.148Z",
    fill: "url(#paint34_radial_110_3490)"
  }), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595.797 84.5326C595.889 84.5824 595.97 84.6499 596.035 84.7311C596.101 84.8123 596.15 84.9057 596.179 85.0058C596.208 85.106 596.218 85.211 596.207 85.3147C596.195 85.4185 596.164 85.519 596.113 85.6105C596.014 85.7963 595.846 85.9352 595.644 85.997C595.443 86.0587 595.226 86.0381 595.039 85.9398C594.855 85.8385 594.718 85.6682 594.659 85.4662C594.599 85.2642 594.623 85.0469 594.723 84.8619C594.772 84.7696 594.838 84.6879 594.919 84.6213C594.999 84.5548 595.092 84.5048 595.192 84.4742C595.291 84.4436 595.396 84.433 595.5 84.443C595.604 84.453 595.705 84.4835 595.797 84.5326Z",
    fill: "url(#paint35_linear_110_3490)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595.721 84.6739C595.866 84.7574 595.972 84.8939 596.018 85.0545C596.063 85.2152 596.044 85.3872 595.965 85.5342C595.886 85.6812 595.753 85.7916 595.594 85.8421C595.434 85.8925 595.262 85.8789 595.113 85.8042C594.968 85.7207 594.862 85.5841 594.816 85.4235C594.771 85.2629 594.79 85.0908 594.869 84.9439C594.948 84.7968 595.081 84.6864 595.24 84.636C595.399 84.5856 595.572 84.5992 595.721 84.6739Z",
    fill: "url(#paint36_radial_110_3490)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M592.364 82.6841C592.547 82.7866 592.683 82.9574 592.741 83.1592C592.798 83.3611 592.774 83.5777 592.673 83.7617C592.573 83.9474 592.404 84.086 592.202 84.1474C592.001 84.2088 591.783 84.188 591.596 84.0896C591.415 83.9869 591.28 83.8168 591.223 83.616C591.165 83.4152 591.189 83.1998 591.289 83.0163C591.337 82.9235 591.403 82.8413 591.484 82.7743C591.564 82.7074 591.657 82.657 591.757 82.6261C591.857 82.5953 591.962 82.5845 592.066 82.5944C592.171 82.6044 592.272 82.6348 592.364 82.6841Z",
    fill: "url(#paint37_linear_110_3490)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M592.288 82.8253C592.433 82.9088 592.539 83.0454 592.584 83.206C592.63 83.3666 592.611 83.5387 592.532 83.6856C592.453 83.8327 592.32 83.9431 592.16 83.9935C592.001 84.0439 591.829 84.0303 591.679 83.9556C591.606 83.9159 591.542 83.8619 591.49 83.7969C591.438 83.7319 591.4 83.6572 591.378 83.5771C591.355 83.4971 591.349 83.4133 591.359 83.3308C591.37 83.2484 591.397 83.1688 591.438 83.0968C591.475 83.0225 591.527 82.9563 591.59 82.9021C591.653 82.848 591.727 82.8071 591.806 82.7818C591.885 82.7565 591.969 82.7473 592.051 82.7548C592.134 82.7623 592.215 82.7862 592.288 82.8253Z",
    fill: "url(#paint38_radial_110_3490)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M563.052 82.7578C563.261 82.3692 563.119 81.8866 562.736 81.6799C562.352 81.4732 561.871 81.6207 561.662 82.0093C561.452 82.3979 561.594 82.8805 561.978 83.0872C562.362 83.2939 562.843 83.1464 563.052 82.7578Z",
    fill: "#31165F"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M562.658 81.8169C562.803 81.9004 562.909 82.037 562.955 82.1976C563 82.3582 562.981 82.5302 562.902 82.6772C562.823 82.8242 562.69 82.9347 562.531 82.9851C562.371 83.0355 562.199 83.0219 562.05 82.9472C561.906 82.8633 561.8 82.7268 561.755 82.5665C561.71 82.4063 561.729 82.2349 561.808 82.0884C561.846 82.014 561.897 81.9478 561.96 81.8937C562.023 81.8396 562.097 81.7987 562.176 81.7734C562.255 81.7481 562.339 81.7389 562.421 81.7464C562.504 81.7539 562.585 81.7778 562.658 81.8169Z",
    fill: "url(#paint39_radial_110_3490)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M553.552 75.1429C553.737 75.2442 553.874 75.4145 553.933 75.6165C553.993 75.8186 553.969 76.0358 553.869 76.2208C553.82 76.3132 553.753 76.3951 553.673 76.4619C553.593 76.5286 553.5 76.5788 553.4 76.6097C553.3 76.6405 553.195 76.6514 553.091 76.6417C552.987 76.6319 552.886 76.6018 552.793 76.553C552.702 76.5027 552.621 76.4349 552.555 76.3533C552.49 76.2718 552.441 76.1782 552.412 76.0778C552.383 75.9775 552.374 75.8723 552.385 75.7684C552.396 75.6645 552.428 75.5639 552.479 75.4723C552.578 75.2865 552.746 75.1475 552.947 75.0858C553.149 75.0241 553.366 75.0446 553.552 75.1429Z",
    fill: "#31165F"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M553.472 75.2928C553.616 75.3763 553.723 75.5129 553.768 75.6735C553.814 75.8341 553.795 76.0061 553.716 76.1531C553.637 76.3001 553.503 76.4106 553.344 76.461C553.185 76.5114 553.012 76.4978 552.863 76.4231C552.719 76.3396 552.612 76.203 552.567 76.0424C552.521 75.8818 552.54 75.7097 552.619 75.5628C552.698 75.4157 552.832 75.3053 552.991 75.2549C553.15 75.2045 553.322 75.2181 553.472 75.2928Z",
    fill: "url(#paint40_radial_110_3490)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.056 79.2784C574.148 79.3283 574.228 79.3957 574.294 79.4769C574.36 79.5582 574.408 79.6515 574.438 79.7517C574.467 79.8518 574.477 79.9568 574.465 80.0606C574.454 80.1643 574.422 80.2648 574.372 80.3563C574.273 80.5421 574.104 80.6811 573.903 80.7428C573.702 80.8045 573.484 80.784 573.298 80.6857C573.114 80.5844 572.977 80.4141 572.917 80.2121C572.858 80.01 572.881 79.7928 572.982 79.6078C573.031 79.5155 573.097 79.4337 573.177 79.3672C573.258 79.3007 573.351 79.2506 573.45 79.22C573.55 79.1894 573.655 79.1788 573.759 79.1889C573.863 79.1989 573.964 79.2293 574.056 79.2784Z",
    fill: "#31165F"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M573.975 79.4281C574.12 79.5117 574.226 79.6482 574.272 79.8088C574.317 79.9695 574.298 80.1415 574.219 80.2885C574.14 80.4355 574.007 80.5459 573.848 80.5963C573.688 80.6468 573.516 80.6332 573.367 80.5585C573.222 80.4749 573.116 80.3384 573.07 80.1778C573.025 80.0172 573.043 79.8451 573.123 79.6981C573.202 79.5511 573.335 79.4407 573.494 79.3903C573.653 79.3399 573.826 79.3534 573.975 79.4281Z",
    fill: "url(#paint41_radial_110_3490)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.762 68.8268C580.854 68.8767 580.935 68.9442 581.001 69.0255C581.066 69.1068 581.115 69.2002 581.145 69.3004C581.175 69.4006 581.184 69.5057 581.173 69.6096C581.162 69.7136 581.131 69.8144 581.081 69.9062C580.981 70.0918 580.812 70.2304 580.61 70.2919C580.408 70.3533 580.191 70.3325 580.004 70.234C579.82 70.1327 579.683 69.9624 579.623 69.7604C579.564 69.5584 579.587 69.3411 579.688 69.1561C579.737 69.0638 579.803 68.9821 579.884 68.9155C579.964 68.849 580.057 68.799 580.157 68.7684C580.256 68.7378 580.361 68.7272 580.465 68.7372C580.569 68.7472 580.67 68.7777 580.762 68.8268Z",
    fill: "#31165F"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.681 68.9766C580.826 69.0601 580.932 69.1966 580.977 69.3572C581.023 69.5179 581.004 69.6899 580.925 69.8369C580.846 69.9839 580.713 70.0943 580.553 70.1447C580.394 70.1951 580.222 70.1816 580.072 70.1069C579.999 70.0671 579.935 70.0132 579.883 69.9481C579.832 69.8831 579.793 69.8084 579.771 69.7283C579.748 69.6483 579.742 69.5646 579.752 69.4821C579.763 69.3996 579.79 69.32 579.831 69.2481C579.869 69.1737 579.92 69.1075 579.983 69.0534C580.046 68.9993 580.12 68.9584 580.199 68.9331C580.278 68.9078 580.362 68.8986 580.444 68.906C580.527 68.9135 580.608 68.9375 580.681 68.9766Z",
    fill: "url(#paint42_radial_110_3490)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M578.561 59.029C578.77 58.6404 578.629 58.1579 578.245 57.9512C577.861 57.7445 577.38 57.8919 577.171 58.2805C576.962 58.6691 577.103 59.1517 577.487 59.3584C577.871 59.5651 578.352 59.4176 578.561 59.029Z",
    fill: "#31165F"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578.168 58.0924C578.313 58.176 578.419 58.3125 578.465 58.4731C578.51 58.6338 578.492 58.8058 578.412 58.9528C578.333 59.0998 578.2 59.2102 578.041 59.2606C577.882 59.3111 577.709 59.2975 577.56 59.2228C577.415 59.1392 577.309 59.0027 577.264 58.8421C577.218 58.6815 577.237 58.5094 577.316 58.3625C577.395 58.2154 577.528 58.105 577.687 58.0546C577.847 58.0042 578.019 58.0178 578.168 58.0924Z",
    fill: "url(#paint43_radial_110_3490)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M565.307 52.4436C565.399 52.4935 565.48 52.5609 565.546 52.6421C565.611 52.7234 565.66 52.8167 565.689 52.9169C565.719 53.017 565.728 53.122 565.717 53.2257C565.706 53.3295 565.674 53.43 565.624 53.5215C565.525 53.7073 565.356 53.8463 565.155 53.908C564.953 53.9697 564.736 53.9492 564.55 53.8508C564.366 53.7498 564.229 53.5801 564.169 53.3788C564.11 53.1774 564.132 52.9607 564.232 52.7758C564.28 52.6831 564.347 52.6008 564.427 52.5339C564.508 52.4669 564.6 52.4166 564.7 52.3857C564.8 52.3548 564.905 52.344 565.01 52.354C565.114 52.3639 565.215 52.3944 565.307 52.4436Z",
    fill: "#31165F"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M565.231 52.5849C565.376 52.6684 565.482 52.805 565.528 52.9656C565.573 53.1262 565.555 53.2982 565.475 53.4452C565.396 53.5922 565.263 53.7027 565.104 53.7531C564.945 53.8035 564.772 53.7899 564.623 53.7152C564.478 53.6317 564.372 53.4951 564.326 53.3345C564.281 53.1739 564.3 53.0018 564.379 52.8549C564.458 52.7079 564.591 52.5974 564.75 52.547C564.91 52.4966 565.082 52.5102 565.231 52.5849Z",
    fill: "url(#paint44_radial_110_3490)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.963 54.5675C556.054 54.6173 556.135 54.6848 556.201 54.766C556.266 54.8472 556.315 54.9406 556.345 55.0407C556.374 55.1409 556.383 55.2459 556.372 55.3496C556.361 55.4534 556.329 55.5539 556.279 55.6454C556.18 55.8312 556.011 55.9701 555.81 56.0319C555.609 56.0936 555.391 56.073 555.205 55.9747C555.02 55.8734 554.883 55.7031 554.824 55.5011C554.765 55.2991 554.788 55.0818 554.889 54.8969C554.937 54.8046 555.004 54.7228 555.084 54.6563C555.165 54.5897 555.257 54.5397 555.357 54.5091C555.457 54.4785 555.562 54.4679 555.666 54.4779C555.77 54.488 555.87 54.5184 555.963 54.5675Z",
    fill: "#31165F"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.882 54.7172C556.027 54.8007 556.133 54.9373 556.179 55.0979C556.224 55.2585 556.205 55.4306 556.126 55.5775C556.047 55.7245 555.914 55.835 555.755 55.8854C555.596 55.9358 555.423 55.9222 555.274 55.8475C555.129 55.764 555.023 55.6275 554.977 55.4668C554.932 55.3062 554.951 55.1342 555.03 54.9872C555.109 54.8402 555.242 54.7298 555.401 54.6793C555.561 54.6289 555.733 54.6425 555.882 54.7172Z",
    fill: "url(#paint45_radial_110_3490)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M549.94 63.3713C550.125 63.4726 550.261 63.6429 550.321 63.8449C550.38 64.0469 550.357 64.2642 550.256 64.4491C550.208 64.5414 550.141 64.6232 550.061 64.6898C549.98 64.7563 549.888 64.8063 549.788 64.8369C549.688 64.8675 549.583 64.8781 549.479 64.8681C549.375 64.8581 549.274 64.8276 549.182 64.7785C549.091 64.7286 549.009 64.6611 548.944 64.5798C548.878 64.4986 548.829 64.4051 548.799 64.3049C548.77 64.2047 548.76 64.0996 548.771 63.9956C548.782 63.8917 548.813 63.7909 548.863 63.6991C548.963 63.5135 549.132 63.3748 549.334 63.3134C549.536 63.252 549.754 63.2728 549.94 63.3713Z",
    fill: "#31165F"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M549.859 63.521C549.932 63.5608 549.997 63.6148 550.049 63.6798C550.1 63.7448 550.139 63.8195 550.161 63.8996C550.184 63.9796 550.19 64.0633 550.179 64.1458C550.169 64.2283 550.142 64.3079 550.1 64.3798C550.063 64.4542 550.012 64.5204 549.949 64.5745C549.885 64.6286 549.812 64.6695 549.733 64.6948C549.654 64.7201 549.57 64.7293 549.487 64.7219C549.405 64.7144 549.324 64.6904 549.251 64.6514C549.106 64.5678 549 64.4313 548.954 64.2706C548.909 64.11 548.928 63.938 549.007 63.791C549.086 63.644 549.219 63.5336 549.378 63.4832C549.538 63.4327 549.71 63.4463 549.859 63.521Z",
    fill: "url(#paint46_radial_110_3490)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M627.007 120.198L627.286 119.681L608.32 110.137L608.063 110.662L627.007 120.198Z",
    fill: "#6F2561"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.405 80.3106L624.108 80.8143L642.606 91.2257L642.795 90.8753L624.405 80.3106Z",
    fill: "#6F2561"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.251 84.7715L609.249 82.9178L637.58 100.562L636.885 101.854L608.251 84.7715Z",
    fill: "url(#paint47_linear_110_3490)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.251 84.7715L614.047 89.5575L636.885 101.854L608.251 84.7715Z",
    fill: "#FF4C61"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M610.12 83.4596L631.841 89.3004L629.185 93.6513L633.811 96.2151L633.005 97.7127L610.12 83.4596Z",
    fill: "#31165F"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M547.243 78.5763C547.243 78.5763 545.126 77.6737 544.58 75.7101L545.198 74.6834C546.034 75.7623 546.812 76.8844 547.529 78.0451L547.243 78.5763Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M609.205 69.8382L601.526 63.2031L601.816 62.6634L609.549 69.1995L609.205 69.8382Z",
    fill: "white"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M571.382 46.5765C571.382 46.5765 572.476 42.9408 574.988 47.3734L571.382 46.5765Z",
    fill: "url(#paint48_linear_110_3490)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M550.412 84.482C550.412 84.482 549.667 87.9989 552.94 86.9765L550.412 84.482Z",
    fill: "url(#paint49_linear_110_3490)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M621.121 108.446C621.121 108.446 590.727 102.987 569.657 95.911L569.616 96.9536C569.616 96.9536 601.361 108.92 619.933 111.323L621.121 108.446Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.705 61.8398L594.852 57.9697L595.129 57.4554L599.982 61.3255L599.705 61.8398Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M590.069 100.65C590.069 100.65 590.615 93.712 592.98 88.1003C592.98 88.1003 591.292 94.0513 590.069 100.65Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583.615 76.8911L603.507 87.4294C603.507 87.4294 596.51 83.2101 583.615 76.8911Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.4 102.328C599.4 102.328 602.712 86.8884 612.086 75.4277C612.1 75.4353 604.683 83.667 599.4 102.328Z",
    fill: "white"
  }))), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548.96 71.3252C548.96 71.3252 550.663 69.8948 547.88 67.0221C548.063 68.495 548.426 69.9401 548.96 71.3252Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M581.257 73.8245C581.257 73.8245 583.383 69.3341 581.484 61.6419C581.47 61.6343 584.07 67.0359 581.257 73.8245Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M576.569 73.4327C576.569 73.4327 580.649 70.7088 578.332 66.0969C578.34 66.1014 579.038 69.0906 576.569 73.4327Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M584.657 78.7462C584.688 79.0544 584.666 79.6036 585.047 79.7143C585.226 79.7446 585.406 79.7649 585.587 79.7751C585.745 79.8056 585.899 79.8521 586.048 79.914C586.292 80.0152 586.559 80.0443 586.819 79.9976C586.986 79.9524 586.935 79.7829 586.861 79.6557C586.799 79.5104 586.7 79.384 586.574 79.2895C586.395 79.1905 586.227 79.0733 586.073 78.9398C586.014 78.8863 585.981 78.7991 585.917 78.7426C585.828 78.6815 585.734 78.6305 585.634 78.5905C585.476 78.5104 585.296 78.4823 585.121 78.5102C584.945 78.5382 584.783 78.6207 584.657 78.7462Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M586.999 81.195C586.951 81.1894 586.906 81.1697 586.87 81.1384C586.833 81.1071 586.807 81.0656 586.794 81.0193C586.977 80.6802 587.708 80.9206 587.664 81.3055C587.616 81.7535 587.095 81.531 586.938 81.3008L586.999 81.195Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M587.874 89.6962C587.884 89.4754 587.847 89.266 587.997 89.0954C588.123 88.9559 588.291 88.8608 588.475 88.8241C588.702 88.7892 588.935 88.8036 589.156 88.8663C589.267 88.8703 589.374 88.9065 589.464 88.9704C589.801 89.2864 589.83 89.8961 589.753 90.3102C589.721 90.5518 589.662 90.789 589.576 91.017C589.496 91.1668 589.449 91.3348 589.395 91.4955C589.37 91.6345 589.316 91.7668 589.237 91.8841C589.143 91.9655 589.038 92.0316 588.924 92.08C588.777 92.1541 588.615 92.1911 588.451 92.1879C588.287 92.1847 588.126 92.1413 587.982 92.0616C587.481 91.7664 587.405 90.9269 587.422 90.3933C587.44 89.9616 587.523 89.2993 587.874 89.6962Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.052 87.6999C588.171 87.8256 588.193 87.8923 588.35 87.8238C588.4 87.792 588.442 87.7499 588.474 87.7003C588.505 87.6507 588.526 87.5948 588.534 87.5364C588.572 87.3236 588.424 86.9487 588.172 86.977C588.045 86.9961 587.792 87.0674 587.705 87.1667C587.651 87.2975 587.644 87.4433 587.687 87.5783C587.73 87.7134 587.819 87.829 587.939 87.9047L588.052 87.6999Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M596.699 83.6222C596.763 83.6864 596.837 83.7388 596.919 83.7767C597.117 83.8832 597.314 83.9897 597.515 84.0977C597.888 84.2986 598.233 84.5574 598.615 84.7628C598.891 84.9028 599.178 85.0195 599.473 85.1118C599.624 85.1669 599.777 85.2142 599.933 85.2535C599.949 85.2225 599.876 85.1757 599.853 85.1449C599.774 85.0405 599.673 84.9499 599.603 84.843C599.447 84.5984 599.279 84.3478 599.105 84.1157C599.066 84.0772 599.032 84.0343 599.003 83.9877C598.975 83.9251 598.959 83.847 598.935 83.7831C598.892 83.6619 598.83 83.5485 598.751 83.4473C598.55 83.229 598.304 83.0577 598.029 82.9459C597.942 82.8987 597.846 82.88 597.76 82.8372C597.666 82.7862 597.568 82.741 597.468 82.702C597.252 82.6354 597.024 82.612 596.798 82.633C596.538 82.6423 596.119 82.588 595.923 82.8175C595.827 82.9267 595.94 83.0492 596.031 83.1238C596.122 83.1983 596.276 83.2848 596.395 83.3746C596.515 83.4644 596.736 83.6635 596.699 83.6222Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595.079 82.4001C595.016 82.2933 594.868 82.1151 594.994 81.9897C595.12 81.8642 595.3 81.9688 595.403 82.0423C595.642 82.2218 595.201 82.4181 595.032 82.2981L595.079 82.4001Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.097 80.7079C598.157 80.8141 598.251 80.897 598.364 80.9428C598.442 80.9688 598.528 80.9637 598.602 80.9285C598.677 80.8934 598.735 80.8308 598.765 80.7539C598.894 80.5137 598.933 80.3196 598.727 80.1468C598.641 80.0936 598.545 80.0593 598.444 80.0461C598.344 80.0329 598.242 80.0412 598.145 80.0703C598.068 80.1004 598.003 80.1549 597.959 80.2255C597.88 80.3725 597.944 80.4979 598.022 80.6237L598.097 80.7079Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.478 79.3132C608.492 78.8574 608.561 78.4049 608.682 77.9653C608.826 77.5952 608.99 77.2334 609.175 76.8818C609.358 76.364 609.504 75.8339 609.613 75.2954C609.711 74.8227 609.923 74.3813 610.232 74.0104C610.36 73.861 610.517 73.7392 610.693 73.6524C610.87 73.5657 611.062 73.5158 611.258 73.5058C611.496 73.5153 611.731 73.5651 611.952 73.6531C612.051 73.7064 612.152 73.7353 612.251 73.7742C612.316 73.7889 612.379 73.8106 612.439 73.8388C612.532 73.889 612.511 73.9285 612.463 74.0161C612.391 74.1752 612.271 74.308 612.12 74.3963C611.869 74.5662 611.65 74.7787 611.472 75.0243C611.29 75.2543 611.1 75.4653 610.933 75.7073L610.435 76.4087C610.289 76.6068 610.136 76.8017 609.991 77.0041C609.845 77.2065 609.728 77.4169 609.599 77.624C609.469 77.8312 609.407 77.9801 609.311 78.1581C609.25 78.2711 609.173 78.3679 609.112 78.4809C609.065 78.5682 609.012 78.6516 608.952 78.7302C608.903 78.8117 608.858 78.8956 608.817 78.9817C608.716 79.1045 608.603 79.2157 608.478 79.3132Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.165 76.1778C608.181 76.2559 608.181 76.3506 608.241 76.4013C608.275 76.4266 608.312 76.4466 608.351 76.4606C608.529 76.5091 608.682 76.2452 608.752 76.1152C608.971 75.7425 609.041 75.301 608.948 74.8791C608.914 74.7352 608.847 74.6012 608.753 74.4873C608.659 74.3734 608.54 74.2827 608.405 74.2222C608.033 74.1133 607.652 74.3746 607.414 74.6474C607.176 74.9202 606.958 75.3056 607.062 75.6534C607.091 75.776 607.161 75.8852 607.259 75.9638C607.35 76.0072 607.442 76.0451 607.537 76.077C607.656 76.1409 607.724 76.2578 607.874 76.2581C607.977 76.263 608.079 76.2349 608.165 76.1778Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M609.357 74.0241C609.318 74.02 609.282 74.0036 609.253 73.9775C609.223 73.9514 609.203 73.9167 609.195 73.8785C609.172 73.8411 609.162 73.7971 609.167 73.7535C609.172 73.7099 609.192 73.6693 609.222 73.6381C609.248 73.6094 609.28 73.5865 609.315 73.5711C609.351 73.5558 609.389 73.5482 609.428 73.549C609.467 73.5497 609.505 73.5588 609.54 73.5756C609.574 73.5923 609.605 73.6164 609.63 73.6461C609.657 73.6925 609.672 73.7449 609.674 73.7987C609.676 73.8524 609.664 73.9057 609.639 73.9537C609.614 74.0057 609.573 74.0477 609.521 74.0727C609.469 74.0978 609.41 74.1044 609.354 74.0915L609.357 74.0241Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M603.099 67.0573C603.069 67.1949 603.093 67.3389 603.168 67.4586C603.181 67.494 603.205 67.5248 603.235 67.5472C603.266 67.5695 603.303 67.5824 603.34 67.5844C603.596 67.5817 603.841 67.4878 604.033 67.3196C604.095 67.2611 604.145 67.1909 604.179 67.113C604.214 67.0352 604.232 66.9513 604.234 66.8662C604.213 66.7154 604.169 66.5687 604.103 66.4315C604.057 66.308 604.003 66.1915 603.935 66.0674C603.905 65.9619 603.842 65.8688 603.756 65.8018C603.669 65.7348 603.563 65.6975 603.454 65.6953C603.335 65.7072 603.221 65.748 603.122 65.814C603.023 65.8801 602.942 65.9696 602.885 66.0744C602.822 66.2238 602.796 66.3859 602.809 66.5474C602.82 66.7172 602.801 66.8602 603.099 67.0573Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M603.508 68.2212C603.574 68.1175 603.66 68.0275 603.76 67.956C603.808 67.9819 603.865 67.9362 603.91 67.9893C603.954 68.0423 603.878 68.1836 603.842 68.2442C603.795 68.3245 603.72 68.3843 603.631 68.4116C603.598 68.4192 603.459 68.461 603.488 68.3858L603.508 68.2212Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.507 81.3671C604.592 81.5003 604.687 81.6496 604.888 81.6011C604.972 81.5642 605.044 81.5029 605.093 81.4252C605.143 81.3474 605.168 81.2567 605.166 81.1644C605.175 81.0742 605.182 80.9725 605.106 80.9171C605.031 80.8617 604.934 80.8243 604.849 80.7786C604.649 80.6706 604.617 80.3839 604.326 80.4641C604.257 80.4861 604.194 80.5228 604.141 80.5715C604.088 80.6202 604.045 80.6798 604.017 80.7463C603.946 80.9739 604.102 81.1925 604.236 81.356L604.507 81.3671Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M603.087 101.761C603.014 102.018 603.015 102.289 603.088 102.545L603.176 102.593C603.231 102.666 603.302 102.726 603.383 102.77C603.464 102.813 603.553 102.839 603.645 102.845C604.229 102.85 604.434 102.341 604.667 101.901C604.9 101.462 605.292 100.863 604.533 100.735C604.197 100.682 603.635 100.555 603.304 100.73C603.126 100.823 603.134 100.923 603.109 101.091C603.05 101.322 603.036 101.562 603.068 101.798L603.087 101.761Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M606.699 96.7804C606.614 96.64 606.427 96.4046 606.506 96.2102C606.585 96.0159 606.685 96.0477 606.819 95.9814C607.113 95.8338 607.456 95.7264 607.629 96.1222C607.663 96.2281 607.672 96.3404 607.656 96.4505C607.64 96.5605 607.598 96.6654 607.535 96.7569C607.423 96.8971 607.095 97.0595 606.942 96.9112L606.699 96.7804Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578.305 52.5927C578.565 52.9553 578.577 52.9801 578.987 53.0728C579.293 53.1803 579.621 53.2105 579.942 53.1606C580.377 53.0302 580.493 52.6374 580.749 52.3379C580.848 52.2528 580.923 52.1431 580.967 52.0199C581.01 51.8967 581.02 51.7643 580.996 51.636C580.932 51.2992 580.806 50.9771 580.626 50.6857C580.312 50.241 579.904 49.8708 579.431 49.6011C578.959 49.3315 578.432 49.1691 577.89 49.1254C577.227 49.078 576.42 49.1067 575.92 49.6287C575.705 49.8421 575.552 50.1096 575.476 50.4029C575.4 50.6963 575.405 51.0047 575.49 51.2956C575.598 51.5768 575.772 51.8278 575.997 52.0278C576.222 52.2277 576.492 52.3707 576.784 52.4448L577.201 52.5378C577.366 52.6068 577.524 52.6919 577.673 52.7919C577.853 52.8562 578.055 52.8407 578.305 52.5927Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.145 54.3025C579.612 54.1128 579.52 54.1402 579.894 54.2649C580.056 54.3229 580.121 54.2775 580.244 54.3875C580.32 54.4768 580.367 54.5869 580.38 54.7036C580.393 54.8203 580.37 54.938 580.314 55.0415C580.237 55.1856 579.834 55.2567 579.696 55.2554C579.611 55.2587 579.527 55.2368 579.454 55.1924C579.382 55.1481 579.324 55.0833 579.287 55.0061L579.145 54.3025Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.655 88.4548C560.9 88.6776 561.203 88.9682 561.588 88.753C561.844 88.6028 561.892 88.1878 561.848 87.9122C561.732 87.4397 561.468 87.0167 561.094 86.7048C560.749 86.4531 560.11 86.6922 559.882 87.0141C559.418 87.6721 560.317 88.637 560.805 88.9691L560.655 88.4548Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.604 90.6691C563.5 90.6645 563.172 90.7063 563.085 90.6233C563.037 90.5974 563.067 90.5222 563.039 90.4783C562.989 90.4061 562.954 90.3239 562.938 90.2372C562.922 90.1505 562.924 90.0613 562.945 89.9757C562.994 89.8021 563.098 89.6493 563.242 89.541C563.386 89.4327 563.562 89.3749 563.742 89.3766C563.859 89.3603 563.979 89.3874 564.078 89.4528C564.177 89.5181 564.248 89.6173 564.28 89.7318C564.322 89.885 564.306 90.0485 564.235 90.1906C564.164 90.3328 564.042 90.4435 563.894 90.5013L563.604 90.6691Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.6 79.6136C617.988 80.088 618.521 80.4223 619.117 80.5656C619.496 80.6819 619.971 80.8757 620.323 80.5877C621.146 79.9119 619.663 78.2531 619.161 77.7755C618.727 77.3575 618.21 77.0356 617.644 76.8307C617.305 76.7214 616.561 76.6343 616.239 76.8543C615.824 77.1375 615.827 77.7264 616.011 78.1167C616.413 79.0622 617.407 79.3967 618.071 80.0859L617.6 79.6136Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.238 79.9946C617.139 80.2157 617.072 80.4495 617.039 80.6893C617.049 80.8189 617.063 81.0232 617.169 81.1241C617.244 81.173 617.33 81.2022 617.42 81.2089C617.509 81.2156 617.599 81.1997 617.68 81.1625C617.742 81.1449 617.798 81.1123 617.844 81.0675C617.89 81.0228 617.923 80.9673 617.942 80.9062C617.954 80.8104 617.879 80.686 617.839 80.603C617.764 80.4508 617.671 80.3078 617.562 80.1768C617.519 80.1079 617.467 80.0447 617.409 79.9883C617.308 79.9049 617.227 79.9599 617.124 79.941L617.238 79.9946Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M621.47 82.9041L621.758 82.6945C621.86 82.7752 622.013 82.8028 622.027 82.9525C622.013 83.095 621.951 83.2286 621.852 83.332C621.802 83.3831 621.736 83.416 621.665 83.4253C621.594 83.4346 621.522 83.4198 621.46 83.3834C621.307 83.3012 621.323 83.1236 621.372 82.9715L621.47 82.9041Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.273 99.6494C620.314 99.712 620.375 99.7595 620.445 99.7849C620.515 99.8104 620.592 99.8123 620.664 99.7905C620.786 99.762 620.893 99.6883 620.964 99.5842C621.034 99.48 621.062 99.3531 621.043 99.229C620.985 98.8697 620.696 98.3498 620.317 98.2407C620.081 98.1718 619.682 98.3177 619.692 98.6037C619.692 98.7648 619.71 98.9254 619.748 99.0821C619.845 99.3128 620.016 99.5048 620.234 99.6281L620.273 99.6494Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.187 50.7274C555.227 50.8765 555.229 50.9469 555.343 51.0408C555.461 51.1574 555.62 51.2235 555.787 51.2251C556.175 51.1395 556.523 50.9223 556.77 50.6102C556.87 50.5075 556.945 50.383 556.989 50.2466C557.032 50.1101 557.044 49.9654 557.022 49.8237C557.009 49.658 556.96 49.4971 556.879 49.3518C556.798 49.2065 556.687 49.0801 556.554 48.9811C556.432 48.8696 556.277 48.7993 556.113 48.7802C555.949 48.761 555.783 48.794 555.638 48.8744C555.33 49.0174 555.054 49.2227 554.829 49.4774C554.748 49.5791 554.693 49.6983 554.668 49.8253C554.643 49.9523 554.648 50.0835 554.683 50.2082C554.734 50.4581 554.873 50.8241 555.187 50.7274Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M557.415 48.9927C557.33 48.947 557.231 48.8938 557.253 48.7997C557.291 48.7224 557.345 48.6536 557.411 48.5976C557.477 48.5416 557.553 48.4995 557.636 48.4738C557.766 48.4439 557.902 48.4628 558.019 48.5271C558.083 48.5925 558.121 48.6789 558.125 48.7701C558.139 48.8362 558.132 48.9051 558.105 48.9669C558.077 49.0288 558.031 49.0804 557.973 49.1144C557.889 49.1607 557.7 49.2885 557.611 49.2039L557.415 48.9927Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.041 50.2091C543.157 50.2937 543.299 50.3341 543.442 50.3232C543.703 50.3042 543.956 50.2259 544.181 50.0942C544.488 49.9395 544.737 49.6904 544.892 49.3834C544.927 49.2603 544.926 49.1295 544.889 49.007C544.851 48.8846 544.779 48.7756 544.68 48.6935C544.423 48.5196 544.112 48.4425 543.802 48.476C543.526 48.5138 543.262 48.6172 543.034 48.7777C542.805 48.9382 542.619 49.151 542.489 49.3983C542.241 49.9752 543.047 50.4347 543.041 50.2091Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.36
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.254 48.8518C546.169 48.8821 546.077 48.8883 545.989 48.8696C545.996 48.7679 545.922 48.6953 545.936 48.5895C545.961 48.4865 546.025 48.3972 546.114 48.3393C546.169 48.299 546.234 48.2741 546.302 48.2671C546.37 48.2601 546.438 48.2712 546.5 48.2993C546.641 48.3753 546.647 48.4401 546.644 48.5879C546.641 48.7357 546.651 48.7231 546.539 48.7829C546.471 48.826 546.399 48.8618 546.324 48.8898L546.254 48.8518Z",
    fill: "white"
  })))), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.482 100.855C599.925 101.094 600.146 101.552 599.971 101.877C599.796 102.202 599.293 102.27 598.849 102.031C598.405 101.792 598.188 101.336 598.363 101.011C598.538 100.686 599.038 100.617 599.482 100.855Z",
    fill: "url(#paint50_linear_110_3490)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.415 100.98C599.766 101.168 599.937 101.527 599.799 101.784C599.66 102.041 599.267 102.095 598.916 101.907C598.566 101.718 598.394 101.36 598.533 101.102C598.671 100.845 599.068 100.793 599.415 100.98Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M610.455 76.4596C610.657 76.5448 610.818 76.7059 610.902 76.9082C610.987 77.1105 610.989 77.3379 610.908 77.5416C610.782 77.7216 610.592 77.8452 610.376 77.8859C610.161 77.9267 609.938 77.8813 609.755 77.7595C609.553 77.6742 609.392 77.513 609.307 77.3105C609.222 77.108 609.219 76.8803 609.3 76.676C609.426 76.4962 609.618 76.3728 609.834 76.3324C610.049 76.292 610.273 76.3377 610.455 76.4596Z",
    fill: "url(#paint51_linear_110_3490)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M610.38 76.5981C610.54 76.6653 610.666 76.7921 610.733 76.9514C610.8 77.1106 610.802 77.2897 610.738 77.4504C610.639 77.5918 610.488 77.6889 610.319 77.7208C610.149 77.7527 609.973 77.7169 609.83 77.621C609.671 77.5539 609.544 77.4271 609.477 77.2678C609.41 77.1085 609.409 76.9294 609.472 76.7688C609.571 76.6273 609.722 76.5302 609.891 76.4983C610.061 76.4664 610.237 76.5023 610.38 76.5981Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M604.787 88.6255C605.029 88.1761 604.865 87.6176 604.42 87.3781C603.975 87.1386 603.418 87.3089 603.176 87.7583C602.934 88.2078 603.099 88.7663 603.544 89.0057C603.988 89.2452 604.545 89.075 604.787 88.6255Z",
    fill: "url(#paint52_linear_110_3490)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.327 87.5504C604.495 87.6429 604.62 87.7981 604.674 87.9822C604.728 88.1663 604.706 88.3642 604.615 88.5327C604.525 88.702 604.371 88.8287 604.188 88.885C604.004 88.9414 603.806 88.9228 603.636 88.8334C603.468 88.7409 603.344 88.5857 603.29 88.4016C603.236 88.2175 603.257 88.0196 603.349 87.8511C603.439 87.6818 603.593 87.5551 603.776 87.4988C603.959 87.4424 604.157 87.461 604.327 87.5504Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M604.807 82.611C605.502 82.6966 606.173 82.9194 606.781 83.2663C607.389 83.6132 607.922 84.0774 608.349 84.6319C608.777 85.1865 609.09 85.8204 609.27 86.4969C609.451 87.1733 609.495 87.8789 609.401 88.5726C609.223 89.9811 608.496 91.2627 607.38 92.1393C606.263 93.0159 604.846 93.417 603.435 93.2556C602.74 93.1695 602.07 92.9466 601.462 92.5995C600.854 92.2525 600.321 91.7883 599.894 91.2338C599.466 90.6793 599.153 90.0456 598.973 89.3693C598.792 88.6931 598.747 87.9876 598.841 87.294C599.019 85.8854 599.745 84.6039 600.862 83.7273C601.979 82.8506 603.396 82.4496 604.807 82.611Z",
    fill: "url(#paint53_radial_110_3490)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M573.391 42.1687C573.945 42.2371 574.481 42.4148 574.966 42.6916C575.451 42.9683 575.877 43.3386 576.218 43.7809C576.559 44.2233 576.809 44.7289 576.954 45.2686C577.098 45.8082 577.134 46.3712 577.059 46.9248C576.916 48.049 576.336 49.0714 575.444 49.7708C574.552 50.4703 573.421 50.7904 572.295 50.662C571.741 50.593 571.206 50.4148 570.721 50.1377C570.235 49.8605 569.81 49.49 569.469 49.0474C569.128 48.6049 568.878 48.0991 568.734 47.5594C568.59 47.0196 568.554 46.4567 568.628 45.903C568.772 44.7793 569.352 43.7573 570.243 43.0584C571.135 42.3594 572.265 42.0398 573.391 42.1687Z",
    fill: "url(#paint54_radial_110_3490)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M537.221 48.6977C537.775 48.7661 538.311 48.9438 538.796 49.2205C539.281 49.4973 539.707 49.8675 540.048 50.3099C540.389 50.7522 540.639 51.2579 540.784 51.7976C540.928 52.3372 540.964 52.9002 540.889 53.4538C540.748 54.5786 540.168 55.6021 539.276 56.3018C538.384 57.0016 537.252 57.3211 536.125 57.1909C535.571 57.1225 535.036 56.9448 534.55 56.6681C534.065 56.3913 533.64 56.0211 533.298 55.5787C532.957 55.1363 532.707 54.6307 532.563 54.091C532.418 53.5514 532.382 52.9884 532.457 52.4348C532.6 51.3103 533.18 50.2874 534.071 49.5878C534.963 48.8882 536.095 48.5684 537.221 48.6977Z",
    fill: "url(#paint55_radial_110_3490)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M551.478 83.7761C551.764 83.8114 552.041 83.9032 552.292 84.0461C552.542 84.1891 552.762 84.3803 552.939 84.6088C553.115 84.8373 553.244 85.0984 553.319 85.3772C553.394 85.656 553.412 85.9468 553.374 86.2328C553.3 86.8141 553 87.3429 552.539 87.7047C552.079 88.0666 551.494 88.2322 550.912 88.1657C550.625 88.1302 550.348 88.0382 550.098 87.895C549.847 87.7518 549.627 87.5603 549.451 87.3315C549.275 87.1027 549.146 86.8413 549.071 86.5623C548.997 86.2833 548.978 85.9923 549.017 85.7061C549.092 85.1257 549.391 84.5978 549.852 84.2366C550.312 83.8754 550.896 83.71 551.478 83.7761Z",
    fill: "url(#paint56_radial_110_3490)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M610.17 75.4387C610.439 75.4709 610.699 75.5563 610.935 75.6898C611.17 75.8234 611.377 76.0023 611.543 76.2164C611.709 76.4305 611.83 76.6755 611.901 76.937C611.971 77.1985 611.989 77.4714 611.953 77.7398C611.885 78.2834 611.605 78.778 611.174 79.1159C610.742 79.4539 610.195 79.6077 609.651 79.544C609.383 79.5112 609.125 79.4255 608.891 79.2921C608.656 79.1586 608.451 78.9799 608.286 78.7665C608.121 78.553 608.001 78.3089 607.931 78.0484C607.861 77.788 607.844 77.5162 607.88 77.249C607.947 76.7069 608.225 76.2131 608.654 75.8743C609.082 75.5356 609.627 75.3791 610.17 75.4387Z",
    fill: "url(#paint57_radial_110_3490)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M599.228 99.7708C599.496 99.8038 599.754 99.8897 599.988 100.023C600.223 100.157 600.428 100.336 600.593 100.55C600.758 100.764 600.878 101.008 600.948 101.269C601.017 101.529 601.034 101.801 600.998 102.069C600.929 102.612 600.649 103.106 600.219 103.444C599.789 103.782 599.242 103.936 598.699 103.874C598.431 103.841 598.172 103.755 597.937 103.622C597.703 103.488 597.497 103.309 597.332 103.095C597.167 102.881 597.046 102.637 596.977 102.376C596.907 102.115 596.89 101.843 596.926 101.575C596.995 101.032 597.275 100.538 597.706 100.2C598.137 99.8622 598.684 99.708 599.228 99.7708Z",
    fill: "url(#paint58_radial_110_3490)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(276.007 275.972) scale(276.007 275.972)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#008BC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(221.372 192.218) scale(352.047 352.003)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C83FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#482088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#403B77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D79D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(425.22 481.752) rotate(-32.6268) scale(126.439 60.6876)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C6AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(269.268 332.713) rotate(151.643) scale(52.3805)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4DBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1BDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_110_3490",
    x1: 291.577,
    y1: 337.249,
    x2: 250.117,
    y2: 343.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA367C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2FBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_110_3490",
    x1: 329.052,
    y1: 316.685,
    x2: 274.373,
    y2: 346.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9579A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(335.19 504.066) rotate(151.643) scale(55.8371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1BDE5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(429.565 303.374) rotate(151.643) scale(57.1759)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4DBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1BDE5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(462.568 446.789) rotate(151.643) scale(67.3269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1BDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_110_3490",
    x1: 525.451,
    y1: 459.275,
    x2: 447.527,
    y2: 470.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA367C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2FBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_110_3490",
    x1: 407.466,
    y1: 509.787,
    x2: 334.769,
    y2: 520.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA367C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2FBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_110_3490",
    x1: 441.315,
    y1: 314.65,
    x2: 395.787,
    y2: 321.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA367C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2FBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_110_3490",
    x1: 508.892,
    y1: 353.989,
    x2: 335.02,
    y2: 447.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9579A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_110_3490",
    x1: 351.441,
    y1: 279.093,
    x2: 256.552,
    y2: 103.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1BDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_110_3490",
    x1: 362.453,
    y1: 170.661,
    x2: 185.061,
    y2: 196.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA367C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2FBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_110_3490",
    x1: 417.902,
    y1: 176.17,
    x2: 238.643,
    y2: 272.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9579A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_110_3490",
    x1: 398.339,
    y1: 241.982,
    x2: 347.985,
    y2: 148.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1BDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4DBEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_110_3490",
    x1: 410.965,
    y1: 542.749,
    x2: 370.063,
    y2: 564.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9579A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_110_3490",
    x1: 535.63,
    y1: 489.793,
    x2: 497.11,
    y2: 510.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9579A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_110_3490",
    x1: 357.554,
    y1: 202.526,
    x2: 190.46,
    y2: 227.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A30B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA367C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2FBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_110_3490",
    x1: 508.65,
    y1: 285.856,
    x2: 482.104,
    y2: 300.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9579A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_110_3490",
    x1: 213.606,
    y1: 329.625,
    x2: 197.472,
    y2: 338.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9579A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_110_3490",
    x1: 371.166,
    y1: 325.643,
    x2: 349.432,
    y2: 328.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA367C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2FBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_110_3490",
    x1: 670.171,
    y1: 121.012,
    x2: 630.746,
    y2: 99.7859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#106D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_110_3490",
    x1: 644.653,
    y1: 87.425,
    x2: 618.257,
    y2: 73.2136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A43440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C73634"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_110_3490",
    x1: 625.15,
    y1: 123.649,
    x2: 598.754,
    y2: 109.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A43440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C73634"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(564.324 61.5728) rotate(-61.702) scale(34.063 61.4731)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6FC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B695E5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(535.84 52.3714) rotate(-61.702) scale(9.15601 8.1686)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AB5E75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#9F577B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#7F458C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#61349C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_110_3490",
    x1: 537.636,
    y1: 53.3353,
    x2: 534.338,
    y2: 51.5598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(607.061 91.0251) rotate(-61.702) scale(16.1744 29.336)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8881BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8375B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7555AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6D43A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(567.39 69.5773) rotate(-61.702) scale(17.199 17.0304)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8881BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8375B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7555AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6D43A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(552.714 62.4888) rotate(-61.702) scale(21.3977 35.3445)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#725EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6D52AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#61349C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_110_3490",
    x1: 576.192,
    y1: 73.8751,
    x2: 553.134,
    y2: 61.4604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7E59"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(628.83 102.43) rotate(-61.702) scale(6.35389 11.5242)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#725EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6D52AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#61349C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(548.011 58.98) rotate(-61.702) scale(11.7094 11.5945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8881BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8375B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7555AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6D43A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_110_3490",
    x1: 596.113,
    y1: 85.6105,
    x2: 594.723,
    y2: 84.8619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DC7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5C4D86"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(595.853 85.627) rotate(-61.702) scale(0.631788 0.625595)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8881BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8375B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7555AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D43A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_110_3490",
    x1: 592.683,
    y1: 83.7635,
    x2: 591.29,
    y2: 83.0134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DC7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5C4D86"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(592.409 83.7722) rotate(-61.702) scale(0.631788 0.625593)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8881BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8375B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7555AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D43A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(562.695 82.7423) rotate(-61.702) scale(0.631788 0.625593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D6FC7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(553.483 76.1876) rotate(-61.702) scale(0.631788 0.625595)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D6FC7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(574.047 80.3443) rotate(-61.702) scale(0.631788 0.625595)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D6FC7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(580.766 69.8823) rotate(-61.702) scale(0.631788 0.625593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D6FC7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(578.232 58.9855) rotate(-61.702) scale(0.631788 0.625595)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D6FC7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(565.253 53.4585) rotate(-61.702) scale(0.631788 0.625595)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D6FC7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(555.886 55.5799) rotate(-61.702) scale(0.631788 0.625595)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D6FC7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(549.85 64.3909) rotate(-61.702) scale(0.631788 0.625593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D6FC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_110_3490",
    x1: 637.732,
    y1: 100.28,
    x2: 608.403,
    y2: 84.4889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A43411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C73634"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_110_3490",
    x1: 572.922,
    y1: 47.4057,
    x2: 573.868,
    y2: 45.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_110_3490",
    x1: 551.023,
    y1: 86.9429,
    x2: 551.913,
    y2: 85.2898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_110_3490",
    x1: 599.971,
    y1: 101.877,
    x2: 598.363,
    y2: 101.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DC7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5C4D86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_110_3490",
    x1: 610.913,
    y1: 77.5447,
    x2: 609.306,
    y2: 76.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DC7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5C4D86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_110_3490",
    x1: 604.787,
    y1: 88.6255,
    x2: 603.179,
    y2: 87.7598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DC7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5C4D86"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(604.135 88.0346) rotate(-82.7944) scale(5.38395 5.317)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0036D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00289E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#001C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#001246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#000A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(572.812 46.3761) rotate(-82.7943) scale(4.29561 4.24218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D68100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9E5F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6E4200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#462A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#271800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#120B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(536.693 52.9221) rotate(-82.7943) scale(4.29561 4.24218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D68100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9E5F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6E4200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#462A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#271800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#120B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(551.257 86.0537) rotate(-82.7944) scale(2.22003 2.19243)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D68100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9E5F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6E4200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#462A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#271800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#120B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(609.889 77.5569) rotate(-82.7944) scale(2.07556 2.04976)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0036D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00289E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#001C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#001246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#000A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_110_3490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(599.009 101.965) rotate(-82.7944) scale(2.07556 2.04975)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0036D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00289E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#001C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#001246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#000A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_3490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 552,
    height: 562,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_110_3490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.3698,
    height: 153.935,
    fill: "white",
    transform: "translate(521 73.1113) rotate(-61.702)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderImg);
export default __webpack_public_path__ + "static/media/header-img.400baa4260daac98f2b2b1ccf08761c2.svg";
export { ForwardRef as ReactComponent };